(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-new"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Product card dots sit inside the card link; stop them from navigating to the product
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.card-gallery__dots')) {
      event.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-postpilot"] && !Shopify.designMode) return;
  try {
    
/* ─────────────────────────────────────────────────────────────
   PostPilot collection — buying options + add to cart.
   Pricing logic mirrors sections/season-reset-campaign.liquid; add to cart
   uses the same Horizon cart:update event + cart drawer as that section.
   ───────────────────────────────────────────────────────────── */
(function () {
  if (!document.querySelector('.pp-campaign')) return;


  /* Mobile "Shop All" → collections bottom sheet. */
  var sheet = document.querySelector('.pp-campaign .pp-tabs');
  function setSheet(open) {
    if (!sheet) return;
    sheet.classList.toggle('show_tabs', open);
    document.body.classList.toggle('pp-sheet-open', open);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pp-campaign .pp-shop-all')) setSheet(true);
    else if (e.target.closest('.pp-campaign .pp-tabs__close') || e.target.closest('.pp-tabs-overlay')) setSheet(false);
  });

  /* Close the sort dropdown when clicking elsewhere. */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.pp-sort[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  function getMatrix(form) {
    if (form._ppMatrix) return form._ppMatrix;
    var script = form.querySelector('.pp-variant-matrix');
    var matrix = {};
    if (script) {
      try { matrix = JSON.parse(script.textContent); }
      catch (e) { console.error('pp-variant-matrix parse error', e); }
    }
    form._ppMatrix = matrix;
    return matrix;
  }

  function selectedValue(form, sel) {
    var b = form.querySelector(sel + ' .is-active');
    return b ? b.dataset.value : '';
  }

  function resolveVariant(form, qty, flavor) {
    var m = getMatrix(form);
    var q = qty !== undefined ? qty : selectedValue(form, '.pp-jars');
    var f = flavor !== undefined ? flavor : selectedValue(form, '.pp-flavors');
    return m[q + '||' + f] || m[q + '||'] || null;
  }

  function isSub(form) { return form.dataset.mode === 'subscribe'; }

  function render(card) {
    var form = card.querySelector('.pp-form');
    if (!form) return;
    var v = resolveVariant(form);
    if (!v) return;
    var sub = isSub(form);

    /* Buying box */
    var box = form.querySelector('.pp-subscribe');
    if (box) {
      var compareEl = box.querySelector('.pp-subscribe__compare');
      var priceEl = box.querySelector('.pp-subscribe__price');
      if (box.dataset.option === 'subscribe') {
        compareEl.textContent = v.compareSubscribe || '';
        priceEl.textContent = v.priceSubscribe;
        box.classList.toggle('is-active', sub);
        var pill = box.querySelector('.pp-pill--offer');
        if (pill) {
          /* Fixed text (e.g. "Special offer 30% off") always shows; a {percentage}
             placeholder uses the variant's own saving and hides when there is none. */
          var tpl = pill.dataset.template;
          if (tpl.indexOf('{percentage}') === -1) {
            pill.textContent = tpl;
            pill.hidden = false;
          } else if (v.subscribeSavingsPct > 0) {
            pill.textContent = tpl.replace('{percentage}', v.subscribeSavingsPct);
            pill.hidden = false;
          } else {
            pill.hidden = true;
          }
        }
      } else {
        compareEl.textContent = v.hasCompareOnetime ? v.compareOnetime : '';
        priceEl.textContent = v.priceOnetime;
      }
    }

    var link = card.querySelector('.pp-onetime-link');
    if (link) link.classList.toggle('is-active', !sub);

    /* Jar boxes: per-jar price + delivery frequency (frequency matched by position) */
    var flavor = selectedValue(form, '.pp-flavors');
    var freqButtons = form.querySelectorAll('.pp-frequency button');
    form.querySelectorAll('.pp-jar').forEach(function (btn, i) {
      var jv = resolveVariant(form, btn.dataset.value, flavor);
      var each = btn.querySelector('.pp-jar__each');
      var freq = btn.querySelector('.pp-jar__freq');
      if (each && jv) each.textContent = (sub ? jv.perJarSubscribe : jv.perJarOnetime) + ' each';
      if (freq) {
        var fb = freqButtons[Math.min(i, freqButtons.length - 1)];
        freq.textContent = '';
        if (sub && fb) {
          /* "30 Days" kept on one line so narrow boxes break as "Delivered Every / 30 Days". */
          var amount = document.createElement('span');
          amount.className = 'pp-jar__freq-amount';
          amount.textContent = fb.dataset.frequencyLabel;
          freq.append('Delivered Every ', amount);
        }
      }
    });

    /* ATC price */
    var atcPrice = card.querySelector('.pp-atc__price');
    var atcCompare = card.querySelector('.pp-atc__compare');
    if (atcPrice) atcPrice.textContent = sub ? v.priceSubscribe : v.priceOnetime;
    if (atcCompare) atcCompare.textContent = sub ? (v.compareSubscribe || '') : (v.hasCompareOnetime ? v.compareOnetime : '');
  }

  function activate(btn) {
    btn.parentElement.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
  }

  function addToCart(card, btn) {
    var form = card.querySelector('.pp-form');
    var v = resolveVariant(form);
    if (!v) return;
    var sub = isSub(form);
    var plan = null;
    if (sub) {
      var jarBtns = Array.prototype.slice.call(form.querySelectorAll('.pp-jar'));
      var idx = Math.max(0, jarBtns.indexOf(form.querySelector('.pp-jar.is-active')));
      var freqButtons = form.querySelectorAll('.pp-frequency button');
      var fb = freqButtons[Math.min(idx, freqButtons.length - 1)];
      plan = fb ? fb.dataset.sellingPlanId : null;
    }

    var label = btn.querySelector('.pp-atc__label');
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';

    var body = new URLSearchParams({ id: v.variantId, quantity: 1 });
    if (plan) body.append('selling_plan', plan);
    /* Ask for the cart drawer's section HTML in the same request (as Horizon's
       assets/product-form.js does) so the drawer morphs from this response
       instead of re-fetching its section, which can fail and leave the drawer
       showing the old cart. */
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId && sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
    });
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) { console.error(data.message); return; }
        /* Horizon's cart components refresh on cart:update; then open the drawer
           (same as sections/season-reset-campaign.liquid). */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(v.variantId),
            data: {
              source: 'product-form-component',
              itemCount: 1,
              productId: data.product_id,
              variantId: v.variantId,
              sections: data.sections
            }
          }
        }));
        setTimeout(function () {
          var cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }, 300);
      })
      .catch(function (err) { console.error('Add to cart failed:', err); })
      .finally(function () {
        btn.disabled = false;
        label.textContent = original;
      });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.pp-campaign .pp-card');
    if (!card) return;
    var form = card.querySelector('.pp-form');
    var btn = e.target.closest('button');
    if (!btn || !form) return;

    if (btn.matches('.pp-subscribe[data-option="subscribe"]')) {
      form.dataset.mode = 'subscribe';
    } else if (btn.matches('.pp-onetime-link')) {
      form.dataset.mode = 'one-time';
    } else if (btn.matches('.pp-jar') || btn.closest('.pp-flavors')) {
      activate(btn);
    } else if (btn.matches('.pp-atc')) {
      addToCart(card, btn);
      return;
    } else {
      return;
    }
    render(card);
  });

  document.querySelectorAll('.pp-campaign .pp-card').forEach(render);

  /* Row alignment: give every card's title/rating/bullets block in a row the
     same height so "Buying Options" lines up across the row (Figma keeps the
     bullets area a fixed height). Single-column mobile skips this. */
  function equalizeRows() {
    var infos = Array.prototype.slice.call(document.querySelectorAll('.pp-campaign .pp-card__info'));
    infos.forEach(function (el) { el.style.minHeight = ''; });
    /* Only cards in the active tab (hidden ones have no layout box). */
    infos = infos.filter(function (el) { return el.offsetParent !== null; });
    var rows = {};
    infos.forEach(function (el) {
      var top = Math.round(el.getBoundingClientRect().top + window.scrollY);
      (rows[top] = rows[top] || []).push(el);
    });
    Object.keys(rows).forEach(function (k) {
      var row = rows[k];
      if (row.length < 2) return;
      var max = Math.max.apply(null, row.map(function (el) { return el.getBoundingClientRect().height; }));
      row.forEach(function (el) { el.style.minHeight = max + 'px'; });
    });
  }
  /* Debounced with a timer, not requestAnimationFrame — rAF is paused in
     background tabs, which would leave the rows unaligned until refocus. */
  var eqTimer = null;
  function scheduleEqualize() {
    clearTimeout(eqTimer);
    eqTimer = setTimeout(equalizeRows, 50);
  }
  scheduleEqualize();
  /* The compiled section script can run after window "load" has already fired. */
  [500, 1500, 3000].forEach(function (t) { setTimeout(scheduleEqualize, t); });
  window.addEventListener('load', scheduleEqualize);
  window.addEventListener('resize', scheduleEqualize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleEqualize);

  /* ─────────────────────────────────────────────────────────────
     Tabs (typed product IDs/handles) + sort + tile positions.
     Every product renders once; the active tab decides which cards
     show and in what order (CSS `order`), then the tiles are slotted
     in after N visible products:
       - reviews / promo ("append"): after product N, or at the end if
         the tab has fewer products;
       - image tile ("require"): only when the tab has more than N.
     ───────────────────────────────────────────────────────────── */
  var root = document.querySelector('.pp-campaign');
  var grid = root.querySelector('.pp-grid');
  var cfgEl = root.querySelector('.pp-tabs-config');
  if (!grid || !cfgEl) return;
  var cfg = { tabs: [] };
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('pp-tabs-config parse error', e); }

  var items = Array.prototype.slice.call(grid.querySelectorAll('.pp-grid__item'));
  var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-pp-tile]'));
  var emptyEl = root.querySelector('.pp-empty');
  var byKey = {};
  items.forEach(function (el) {
    byKey[el.dataset.id] = el;
    byKey[el.dataset.handle] = el;
  });

  function tabCards(slug) {
    var tab = (cfg.tabs || []).filter(function (t) { return t.slug === slug; })[0];
    /* Unknown tab, or a tab with no IDs: every product (all tabs combined). */
    if (!tab || !tab.items.length) return items.slice();
    var seen = [];
    tab.items.forEach(function (key) {
      var el = byKey[String(key).trim()];
      if (el && seen.indexOf(el) === -1) seen.push(el);
    });
    return seen;
  }

  function sortCards(list, mode) {
    var out = list.slice();
    var price = function (el) { return parseInt(el.dataset.price, 10) || 0; };
    var title = function (el) { return (el.dataset.title || '').toLowerCase(); };
    if (mode === 'price-asc') out.sort(function (a, b) { return price(a) - price(b); });
    else if (mode === 'price-desc') out.sort(function (a, b) { return price(b) - price(a); });
    else if (mode === 'title-asc') out.sort(function (a, b) { return title(a).localeCompare(title(b)); });
    else if (mode === 'title-desc') out.sort(function (a, b) { return title(b).localeCompare(title(a)); });
    return out;
  }

  var state = { tab: null, sort: 'featured' };

  function apply() {
    var visible = sortCards(tabCards(state.tab), state.sort);
    items.forEach(function (el) { el.style.display = 'none'; });
    tiles.forEach(function (el) { el.style.display = 'none'; el.style.order = ''; });

    var order = 0;
    var placed = [];
    function placeTilesAt(index) {
      tiles.forEach(function (tile) {
        if (placed.indexOf(tile) === -1 && parseInt(tile.dataset.position, 10) === index) {
          tile.style.display = '';
          tile.style.order = order++;
          placed.push(tile);
        }
      });
    }
    visible.forEach(function (el, i) {
      placeTilesAt(i);
      el.style.display = '';
      el.style.order = order++;
    });
    /* Short tabs: reviews/promo still show after the last product. */
    tiles.forEach(function (tile) {
      if (placed.indexOf(tile) === -1 && tile.dataset.mode === 'append' && visible.length > 0) {
        tile.style.display = '';
        tile.style.order = order++;
      }
    });

    if (emptyEl) emptyEl.hidden = visible.length > 0;

    root.querySelectorAll('.pp-tabs [data-pp-tab]').forEach(function (el) {
      el.classList.toggle('active-collection', el.dataset.ppTab === state.tab);
    });
    root.querySelectorAll('[data-pp-sort]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.ppSort === state.sort);
    });
    scheduleEqualize();
  }

  function validSlug(slug) {
    return (cfg.tabs || []).some(function (t) { return t.slug === slug; });
  }
  function firstSlug() {
    return cfg.tabs && cfg.tabs[0] ? cfg.tabs[0].slug : null;
  }

  var hash = decodeURIComponent(location.hash.slice(1));
  state.tab = validSlug(hash) ? hash : firstSlug();
  apply();

  root.addEventListener('click', function (e) {
    var tabLink = e.target.closest('.pp-tabs [data-pp-tab]');
    if (tabLink) {
      e.preventDefault();
      state.tab = tabLink.dataset.ppTab;
      if (history.replaceState) history.replaceState(null, '', '#' + state.tab);
      apply();
      setSheet(false);
      return;
    }
    var sortBtn = e.target.closest('[data-pp-sort]');
    if (sortBtn) {
      state.sort = sortBtn.dataset.ppSort;
      apply();
      var details = sortBtn.closest('details');
      if (details) details.removeAttribute('open');
    }
  });

  window.addEventListener('hashchange', function () {
    var h = decodeURIComponent(location.hash.slice(1));
    if (validSlug(h) && h !== state.tab) { state.tab = h; apply(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-featured-collection"] && !Shopify.designMode) return;
  try {
    
function adjustCarouselCellHeight() {
  const carouselCells = document.querySelectorAll(".Carousel__Cell");
  if (carouselCells.length > 0) {
    let maxHeight = 0;
    carouselCells.forEach(cell => {
      cell.style.height = "auto";
      const cellHeight = cell.offsetHeight;
      if (cellHeight > maxHeight) {
        maxHeight = cellHeight;
      }
    });
    carouselCells.forEach(cell => {
      cell.style.height = (maxHeight - 1) + "px";
    });
  }
}
let debounceTimer;
function debounce(func, delay) {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
}
adjustCarouselCellHeight();
window.addEventListener("resize", () => {
  debounce(adjustCarouselCellHeight, 100); // 100ms delay
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-days-sale-2026-onetime"] && !Shopify.designMode) return;
  try {
    
// ─────────────────────────────────────────────────────────────
//  Sticky buttons: back-to-top + cart fab
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector('.md-campaign');
  if (!root) return;

  /* Back-to-top: fade in past 40% scroll, smooth scroll on click */
  const btt = root.querySelector('.md-back-to-top');
  if (btt) {
    window.addEventListener('scroll', function () {
      const pageH = document.documentElement.scrollHeight - window.innerHeight;
      const pct = pageH > 0 ? (window.scrollY / pageH) * 100 : 0;
      btt.classList.toggle('visible', pct > 40);
    }, { passive: true });

    btt.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Cart fab: opens the Horizon cart drawer; hidden when cart is empty */
  const fab = root.querySelector('.md-cart-fab');
  if (fab) {
    fab.addEventListener('click', function (e) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open();
      }
      // else: fall through to href="/cart" navigation
    });

    const refreshFab = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(c => fab.classList.toggle('is-empty', !c || !c.item_count))
        .catch(() => {});
    };

    document.addEventListener('cart:update', refreshFab);
    refreshFab();
  }
})();

// ─────────────────────────────────────────────────────────────
//  Category filter / grid sort order
//  Reads sort lists from the #md-filter-config JSON tag emitted
//  above (one entry per filter_category block).
// ─────────────────────────────────────────────────────────────
let _mdCustomSortOrder = {};
const _mdConfigEl = document.getElementById('md-filter-config');
if (_mdConfigEl) {
  try { _mdCustomSortOrder = JSON.parse(_mdConfigEl.textContent); }
  catch (e) { console.error('md-filter-config parse error', e); }
}

// ─────────────────────────────────────────────────────────────
//  Row alignment: keep cards lined up across each row so swatch
//  tops AND Add-to-Cart buttons share the same Y coordinate.
//
//  Two equalization passes:
//    • SINGLE: each selector equalized independently.
//      Used for sections that have similar content per card and
//      whose own height directly matters (.bf-grid-top settles
//      everything below; .buying-option settles where .jars-option
//      starts).
//    • PAIR : two selectors equalized as a summed total.
//      Used when the two sections trade height (subscribe mode adds
//      to .jars-option but removes installments from
//      .su-shipping-install — net height per card differs even
//      though sum stays similar). Padding is added to the second
//      selector to bring the sum up to the row's max.
//
//  Robust against:
//    • Late {% javascript %} loading (handles `load` already-fired)
//    • Web-font swap reflow (document.fonts.ready)
//    • Image load reflow (window.load)
//    • Filter-applied CSS `order` reordering visual position
//    • Subpixel rounding (3px row tolerance)
//    • Any async content shift in a card (ResizeObserver)
//    • Form state changes — buying-option / jars-option clicks
// ─────────────────────────────────────────────────────────────
const MD_EQ_SELECTORS = ['.bf-grid-top', '.buying-option'];
const MD_EQ_PAIRS     = [['.jars-option', '.su-shipping-install']];
const MD_ROW_TOLERANCE_PX = 3;

function mdEqualHeights() {
  const items = Array.from(document.querySelectorAll('.bf-grid-block'))
    .filter(el => el.offsetParent !== null); /* skip filtered-out cards */
  if (!items.length) return;

  /* Reset everything to natural height so we measure real content. */
  const allSels = MD_EQ_SELECTORS.concat(MD_EQ_PAIRS.flat());
  allSels.forEach(sel => {
    items.forEach(item => {
      const el = item.querySelector(sel);
      if (el) el.style.height = 'auto';
    });
  });

  /* Sort by visual position (top, then left) so DOM order doesn't
     matter — important after the filter sets CSS `order` values. */
  const sorted = items
    .map(el => {
      const r = el.getBoundingClientRect();
      return { el, top: r.top, left: r.left };
    })
    .sort((a, b) => (a.top - b.top) || (a.left - b.left));

  /* Group consecutive items into rows (matching y within tolerance). */
  let i = 0;
  while (i < sorted.length) {
    const rowY = sorted[i].top;
    let j = i;
    while (j < sorted.length && Math.abs(sorted[j].top - rowY) <= MD_ROW_TOLERANCE_PX) j++;
    const rowItems = sorted.slice(i, j).map(o => o.el);

    /* SINGLE pass: independent per-selector equalization */
    MD_EQ_SELECTORS.forEach(sel => {
      let maxH = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(sel);
        if (el) maxH = Math.max(maxH, el.getBoundingClientRect().height);
      });
      if (maxH > 0) {
        rowItems.forEach(item => {
          const el = item.querySelector(sel);
          if (el) el.style.height = maxH + 'px';
        });
      }
    });

    /* PAIR pass: equalize sum(sel1, sel2). Pads the SECOND selector
       up to (rowMaxSum − thisCardSum) so total height matches and
       Add-to-Cart lands on the same Y across the row. */
    MD_EQ_PAIRS.forEach(([sel1, sel2]) => {
      const measurements = rowItems.map(item => {
        const a = item.querySelector(sel1);
        const b = item.querySelector(sel2);
        const h1 = a ? a.getBoundingClientRect().height : 0;
        const h2 = b ? b.getBoundingClientRect().height : 0;
        return { a, b, h1, h2, sum: h1 + h2 };
      });
      const maxSum = measurements.reduce((m, r) => Math.max(m, r.sum), 0);
      if (maxSum <= 0) return;
      measurements.forEach(({ b, h2, sum }) => {
        if (b && sum < maxSum) {
          b.style.height = (h2 + (maxSum - sum)) + 'px';
        }
      });
    });

    i = j;
  }
}

/* rAF-debounced wrapper so resize/observer/click bursts coalesce */
let _mdEqRaf = null;
function mdScheduleEqualHeights() {
  if (_mdEqRaf) return;
  _mdEqRaf = requestAnimationFrame(() => {
    _mdEqRaf = null;
    mdEqualHeights();
  });
}

/* Initial run — covers the case where window.load already fired */
if (document.readyState === 'complete') {
  mdScheduleEqualHeights();
} else {
  window.addEventListener('load', mdEqualHeights);
}

/* Re-equalize once webfonts swap in (Peachi, DM Sans, etc.) */
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(mdScheduleEqualHeights);
}

window.addEventListener('resize', mdScheduleEqualHeights);

/* Watch every card for any internal content change (lazy images,
   metafield text, badges injected by JS, etc.) and re-equalize. */
if ('ResizeObserver' in window) {
  const _mdRO = new ResizeObserver(mdScheduleEqualHeights);
  document.querySelectorAll('.bf-grid-block').forEach(b => _mdRO.observe(b));
}

jQuery(function ($) {
  if (!document.getElementById('bfcat-terms')) return; /* filter turned off -> show all products */
  const $blocks = $(".bf-grid-block");
  const byHandle = {};
  $blocks.each(function () {
    const h = $(this).data("filter-handle");
    (byHandle[h] = byHandle[h] || []).push(this);
  });

  $("#bfcat-terms").on("click", ".filter-btn", function (e) {
    e.preventDefault();
    const cat = $(this).data("category");
    setActive(this);
    history.pushState(null, "", "#" + cat);
    filterAndOrder(cat);
  });

  /* First run: respect URL hash, else first defined slug */
  const _slugs = Object.keys(_mdCustomSortOrder);
  const start = _mdCustomSortOrder[location.hash.slice(1)]
              ? location.hash.slice(1)
              : (_slugs[0] || "all-products");
  setActive($(`.filter-btn[data-category='${start}']`));
  filterAndOrder(start);

  function filterAndOrder(cat) {
    const list   = _mdCustomSortOrder[cat] || [];
    const max    = 9999;
    let current  = 0;

    $blocks.each(function () { this.style.order = max; });
    list.forEach(h =>
      (byHandle[h] || []).forEach(el => { el.style.order = current++; })
    );
    if (cat === "all") {
      $blocks.filter(function () { return this.style.order == max; })
             .each(function () { this.style.order = current++; });
    }

    $blocks.hide();
    list.forEach(h => (byHandle[h] || []).forEach(el => el.style.display = ""));
    if (cat === "all") $blocks.show();

    $(".cm-header").attr("data-bf-category", cat);
    mdEqualHeights();
  }

  function setActive(btn) {
    $(".filter-btn").removeClass("active");
    $(btn).addClass("active");
  }
});

// ─────────────────────────────────────────────────────────────
//  Super-product-form: variant + buying-option + ATC runtime
// ─────────────────────────────────────────────────────────────
(function (jQuery) {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.super-product-form');
  if (!forms.length) return;

  /* Click delegation for every super-product-form on the page */
  document.body.addEventListener('click', e => {
    const btn = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.super-product-form');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      mdScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('jars-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      mdScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  /* First paint */
  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); f.classList.remove('loading'); });

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const jarButtons = $$$('.jars-option button', form);

    jarButtons.forEach(btn => {
      const txt = isSub ? btn.dataset.displayPerjarSub : btn.dataset.displayPerjarOnetime;
      const priceEl = btn.querySelector('.price-value');
      if (priceEl) priceEl.innerHTML = `${txt} each`;
    });
  }

  function updateBuyingArea(form) {
    const jar = $$('.jars-option .active', form);
    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    const onePrice = parseInt(jar.dataset.priceOnetime || "0");
    const subPrice = parseInt(jar.dataset.priceSubscribe || "0");
    const compareAt = parseInt(jar.dataset.compareAtPrice || "0");

    const displayOne = jar.dataset.displayOnetime;
    const displaySub = jar.dataset.displaySubscribe;
    const displayCompareOne = jar.dataset.displayCompareOnetime;
    const regularPrice = parseInt(jar.dataset.priceRegular || "0");
    const displayRegular = jar.dataset.displayRegular;
    const displayCompareSub = jar.dataset.displayCompareSubscribe;

    if (one) {
      one.innerHTML = (compareAt > onePrice && displayCompareOne)
        ? `<s>${displayCompareOne}</s> ${displayOne}`
        : `${displayOne}`;
    }

    if (sub && subBtn) {
      sub.innerHTML = (compareAt > subPrice && displayCompareSub)
        ? `<s>${displayCompareSub}</s> ${displaySub}`
        : `${displaySub}`;

      /* Fill the dollar savings inside "Subscribe & Save $X.XX" */
      const extraEl = subBtn.querySelector('.extra-savings-value');
      if (extraEl) extraEl.innerHTML = jar.dataset.subscribeSavings || '';
    }

    /* Frequency box visibility (hidden by default; shown when subscribe) */
    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';

    /* Add-to-cart button — pay total + strike the "regular" (same basis as the pill
       and badge: compare-at for bundles, else base×N, floored at price). So the CTA's
       crossed price matches the SAVE X% pill and the pricing table. */
    const atcBtn = $$('.add-to-cart', form);
    if (atcBtn) {
      const totalEl   = atcBtn.querySelector('.atc-total');
      const compareEl = atcBtn.querySelector('.atc-compare');
      let atcTotal, atcCompare;
      if (subMode) {
        atcTotal   = displaySub;
        atcCompare = (regularPrice > subPrice && displayRegular) ? displayRegular : '';
      } else {
        atcTotal   = displayOne;
        atcCompare = (regularPrice > onePrice && displayRegular) ? displayRegular : '';
      }
      if (totalEl)   totalEl.textContent   = atcTotal || '';
      if (compareEl) compareEl.textContent = atcCompare || '';
    }

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }

    /* Auto-select delivery option based on jar count */
    if (subMode && subBox) {
      const activeJar = $$('.jars-option .active', form);
      const jarCount = parseInt(activeJar.dataset.jars || "1");
      const freqButtons = $$$('.frequency-option button', form);

      freqButtons.forEach(btn => btn.classList.remove('active'));
      const index = Math.min(jarCount === 1 ? 0 : jarCount === 2 ? 1 : 2, freqButtons.length - 1);
      freqButtons[index].classList.add('active');
      updateVariantLabelsWithFrequency(form);
    }

    /* Klarna/Shop Pay installment value */
    const shippingInstallment = $$('.su-installment', form);
    const installmentValue = $$('.installment-value', form);
    const rawOnetimeHTML = jar?.dataset.displayOnetime;

    if (shippingInstallment && installmentValue) {
      if (subMode) {
        shippingInstallment.style.display = 'none';
      } else {
        shippingInstallment.style.display = 'block';
        if (rawOnetimeHTML) updateInstallmentDisplay(rawOnetimeHTML, installmentValue);
      }
    }
  }

  function addToCart(form) {
    const variantId   = $$('.jars-option .active', form).dataset.variantId;
    const subMode     = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const planBtn     = $$('.frequency-option .active', form);
    const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
    const quantity    = 1;

    const btn = $$('.add-to-cart', form);
    btn.disabled = true;
    const btnLabel = btn.querySelector('.atc-text');
    if (btnLabel) { btnLabel.textContent = 'Adding…'; } else { btn.textContent = 'Adding…'; }

    const formData = new URLSearchParams({ id: variantId, quantity: quantity });
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          console.error(data.message);
          return;
        }

        /* Notify the Horizon cart drawer (matches pp-superform-horizon.js) */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: variantId.toString(),
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: data.product_id,
              variantId: variantId
            }
          }
        }));

        /* Open the cart drawer after a short delay so it can re-render */
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 300);
      })
      .catch(error => {
        console.error("There was an error adding the product to the cart:", error);
      })
      .finally(() => {
        btn.disabled = false;
        const t = btn.querySelector('.atc-text');
        if (t) { t.textContent = 'Add to Cart'; updateBuyingArea(form); }
        else { btn.textContent = 'Add to Cart'; }
      });
  }

  function updateVariantLabelsWithFrequency(form) {
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const freqButtons = $$$('.frequency-option button', form);
    const jarButtons = $$$('.jars-option button', form);

    if (!subMode || !freqButtons.length || !jarButtons.length) return;

    jarButtons.forEach((btn) => {
      const jars = parseInt(btn.dataset.jars || "1");
      const freqIndex = Math.min(jars === 1 ? 0 : jars === 2 ? 1 : 2, freqButtons.length - 1);
      const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();
      if (!freqTextRaw) return;

      const labelText = `Delivered Every ${freqTextRaw}`;
      const existingSpan = btn.querySelector('.frequency-label');
      if (existingSpan) existingSpan.remove();

      const titleEl = btn.querySelector('.price-title');
      if (titleEl && titleEl.parentNode) {
        const span = document.createElement('span');
        span.className = 'frequency-label';
        span.style.fontSize = '12px';
        span.style.color = '#666';
        span.style.display = 'block';
        span.textContent = labelText;
        titleEl.parentNode.insertBefore(span, titleEl.nextSibling);
      }
    });
  }

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function extractAmountAndCurrency(htmlString) {
    const decoded = decodeHTML(htmlString);
    const match = decoded.match(/([€£$])?\s*([\d.,]+)\s*(\w+)?/i);
    if (!match) return { amount: 0, symbol: "", currency: "" };

    let symbol = match[1] || "";
    let rawAmount = match[2];
    let currency = (match[3] || "").trim();

    /* Normalize EU number formatting */
    if (rawAmount.includes(',') && rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(/\./g, '').replace(',', '.');
    } else if (rawAmount.includes(',') && !rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(',', '.');
    }

    return { symbol: symbol.trim(), amount: parseFloat(rawAmount), currency };
  }

  function updateInstallmentDisplay(displayAttr, valueEl) {
    const { symbol, amount, currency } = extractAmountAndCurrency(displayAttr);
    if (!amount || !valueEl) return;

    const quarter = amount / 4;
    const formatted = quarter.toFixed(2);
    valueEl.innerHTML = `${symbol}${formatted} ${currency}`.trim();
  }

  /* Tiny debug helper */
  window.debugTile = sel => updateBuyingArea($$(sel));
})(window.GemQuery || jQuery);

// ─────────────────────────────────────────────────────────────
//  Pro / Basic bullets toggle (special-cased products only)
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const configs = [
    { handle: 'sale-the-ultimate-weight-loss-protocol-3-0', variantId: '45882472661163' },
    { handle: 'new-improved-protocol',                     variantId: '44667017658539' }
  ];

  configs.forEach(({ handle, variantId }) => {
    const gridBlock = document.querySelector(`.bf-grid-block[data-filter-handle="${handle}"]`);
    if (!gridBlock) return;

    const proButton = gridBlock.querySelector(`button[data-variant-id="${variantId}"]`);
    const bullets   = gridBlock.querySelector('.wlp-bullets');
    if (!proButton || !bullets) return;

    const updateBulletsVisibility = () => {
      bullets.style.display = proButton.classList.contains('active') ? 'block' : 'none';
    };

    updateBulletsVisibility();

    const buttons = gridBlock.querySelectorAll('.jars-option button');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateBulletsVisibility();
      });
    });
  });
});

// ─────────────────────────────────────────────────────────────
//  "xxx Products Left" fake-scarcity counter
//  Per-product deterministic start (hashed handle), persisted
//  in localStorage, decays over time (1–2/tick), capped at 50
//  drops/visit, paused when the tab is hidden.
// ─────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const scriptVersion = "v7";

  const today = new Date();
  const inventoryByDate = {
    "2025-11-24": { upper: 1700, lower: 1200 },
    "2025-11-25": { upper: 1700, lower: 1200 },
    "2025-11-26": { upper: 1200, lower: 900 },
    "2025-11-27": { upper: 1200, lower: 900 },
    "2025-11-28": { upper: 900,  lower: 700 },
    "2025-11-29": { upper: 900,  lower: 700 },
    "2025-11-30": { upper: 700,  lower: 400 },
    "2025-12-01": { upper: 700,  lower: 400 },
    "2025-12-02": { upper: 400,  lower: 250 },
    "2025-12-03": { upper: 400,  lower: 250 },
    "2025-12-04": { upper: 250,  lower: 150 },
    "2025-12-05": { upper: 250,  lower: 150 },
    "2025-12-06": { upper: 150,  lower: 80  },
    "2025-12-07": { upper: 150,  lower: 50  }
  };

  const todayKey = today.toISOString().split("T")[0];
  const range = inventoryByDate[todayKey] || { upper: 1700, lower: 1200 };

  const productBlocks = document.querySelectorAll(".bf-grid-block");

  productBlocks.forEach((block) => {
    const handle = block.getAttribute("data-filter-handle");
    const counterEl = block.querySelector(".randomnumber span");
    if (!handle || !counterEl) return;

    const baseKey = btoa(handle).slice(0, 8);
    const countKey = `invdata-${baseKey}`;
    const timeKey = `invts-${baseKey}`;
    const now = Date.now();

    let saved = JSON.parse(localStorage.getItem(countKey));
    let visitStart = parseInt(localStorage.getItem(timeKey)) || now;

    /* Reset if version changed or not found */
    if (!saved || saved.version !== scriptVersion) {
      const spread = Math.abs(hashCode(handle)) % 120;
      const variation = getRandom(-spread / 2, spread / 2);
      const startNum = Math.max(range.lower, Math.min(range.upper, Math.floor(range.upper - 10 - variation)));

      saved = {
        current: startNum,
        lower: range.lower,
        initial: startNum,
        version: scriptVersion
      };
      localStorage.setItem(countKey, JSON.stringify(saved));
      localStorage.setItem(timeKey, now);
    }

    counterEl.textContent = saved.current;

    let visibilityPaused = false;

    function updateCounter() {
      if (document.hidden) {
        visibilityPaused = true;
        return;
      }

      let data = JSON.parse(localStorage.getItem(countKey));
      let timeSpent = (Date.now() - visitStart) / 1000;
      let dropRate;

      if (timeSpent < 300) dropRate = getRandom(1, 2);
      else if (timeSpent < 900) dropRate = getRandom(1, 2);
      else if (timeSpent < 1800) dropRate = 1;
      else dropRate = Math.random() < 0.4 ? 1 : 0;

      const maxDrop = 50;
      const droppedSoFar = saved.initial - data.current;
      if (droppedSoFar >= maxDrop) return;

      if (data.current > data.lower) {
        data.current = Math.max(data.lower, data.current - dropRate);
        counterEl.textContent = data.current;
        localStorage.setItem(countKey, JSON.stringify(data));
      }

      setTimeout(updateCounter, getRandom(10000, 20000));
    }

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && visibilityPaused) {
        visibilityPaused = false;
        updateCounter();
      }
    });

    setTimeout(updateCounter, getRandom(3000, 6000));
  });

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-days-sale-2026"] && !Shopify.designMode) return;
  try {
    
// ─────────────────────────────────────────────────────────────
//  Sticky buttons: back-to-top + cart fab
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector('.md-campaign');
  if (!root) return;

  /* Back-to-top: fade in past 40% scroll, smooth scroll on click */
  const btt = root.querySelector('.md-back-to-top');
  if (btt) {
    window.addEventListener('scroll', function () {
      const pageH = document.documentElement.scrollHeight - window.innerHeight;
      const pct = pageH > 0 ? (window.scrollY / pageH) * 100 : 0;
      btt.classList.toggle('visible', pct > 40);
    }, { passive: true });

    btt.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Cart fab: opens the Horizon cart drawer; hidden when cart is empty */
  const fab = root.querySelector('.md-cart-fab');
  if (fab) {
    fab.addEventListener('click', function (e) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open();
      }
      // else: fall through to href="/cart" navigation
    });

    const refreshFab = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(c => fab.classList.toggle('is-empty', !c || !c.item_count))
        .catch(() => {});
    };

    document.addEventListener('cart:update', refreshFab);
    refreshFab();
  }
})();

// ─────────────────────────────────────────────────────────────
//  Category filter / grid sort order
//  Reads sort lists from the #md-filter-config JSON tag emitted
//  above (one entry per filter_category block).
// ─────────────────────────────────────────────────────────────
let _mdCustomSortOrder = {};
const _mdConfigEl = document.getElementById('md-filter-config');
if (_mdConfigEl) {
  try { _mdCustomSortOrder = JSON.parse(_mdConfigEl.textContent); }
  catch (e) { console.error('md-filter-config parse error', e); }
}

// ─────────────────────────────────────────────────────────────
//  Row alignment: keep cards lined up across each row so swatch
//  tops AND Add-to-Cart buttons share the same Y coordinate.
//
//  Two equalization passes:
//    • SINGLE: each selector equalized independently.
//      Used for sections that have similar content per card and
//      whose own height directly matters (.bf-grid-top settles
//      everything below; .buying-option settles where .jars-option
//      starts).
//    • PAIR : two selectors equalized as a summed total.
//      Used when the two sections trade height (subscribe mode adds
//      to .jars-option but removes installments from
//      .su-shipping-install — net height per card differs even
//      though sum stays similar). Padding is added to the second
//      selector to bring the sum up to the row's max.
//
//  Robust against:
//    • Late {% javascript %} loading (handles `load` already-fired)
//    • Web-font swap reflow (document.fonts.ready)
//    • Image load reflow (window.load)
//    • Filter-applied CSS `order` reordering visual position
//    • Subpixel rounding (3px row tolerance)
//    • Any async content shift in a card (ResizeObserver)
//    • Form state changes — buying-option / jars-option clicks
// ─────────────────────────────────────────────────────────────
const MD_EQ_SELECTORS = ['.bf-grid-top', '.buying-option'];
const MD_EQ_PAIRS     = [['.jars-option', '.su-shipping-install']];
const MD_ROW_TOLERANCE_PX = 3;

function mdEqualHeights() {
  const items = Array.from(document.querySelectorAll('.bf-grid-block'))
    .filter(el => el.offsetParent !== null); /* skip filtered-out cards */
  if (!items.length) return;

  /* Reset everything to natural height so we measure real content. */
  const allSels = MD_EQ_SELECTORS.concat(MD_EQ_PAIRS.flat());
  allSels.forEach(sel => {
    items.forEach(item => {
      const el = item.querySelector(sel);
      if (el) el.style.height = 'auto';
    });
  });

  /* Sort by visual position (top, then left) so DOM order doesn't
     matter — important after the filter sets CSS `order` values. */
  const sorted = items
    .map(el => {
      const r = el.getBoundingClientRect();
      return { el, top: r.top, left: r.left };
    })
    .sort((a, b) => (a.top - b.top) || (a.left - b.left));

  /* Group consecutive items into rows (matching y within tolerance). */
  let i = 0;
  while (i < sorted.length) {
    const rowY = sorted[i].top;
    let j = i;
    while (j < sorted.length && Math.abs(sorted[j].top - rowY) <= MD_ROW_TOLERANCE_PX) j++;
    const rowItems = sorted.slice(i, j).map(o => o.el);

    /* SINGLE pass: independent per-selector equalization */
    MD_EQ_SELECTORS.forEach(sel => {
      let maxH = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(sel);
        if (el) maxH = Math.max(maxH, el.getBoundingClientRect().height);
      });
      if (maxH > 0) {
        rowItems.forEach(item => {
          const el = item.querySelector(sel);
          if (el) el.style.height = maxH + 'px';
        });
      }
    });

    /* PAIR pass: equalize sum(sel1, sel2). Pads the SECOND selector
       up to (rowMaxSum − thisCardSum) so total height matches and
       Add-to-Cart lands on the same Y across the row. */
    MD_EQ_PAIRS.forEach(([sel1, sel2]) => {
      const measurements = rowItems.map(item => {
        const a = item.querySelector(sel1);
        const b = item.querySelector(sel2);
        const h1 = a ? a.getBoundingClientRect().height : 0;
        const h2 = b ? b.getBoundingClientRect().height : 0;
        return { a, b, h1, h2, sum: h1 + h2 };
      });
      const maxSum = measurements.reduce((m, r) => Math.max(m, r.sum), 0);
      if (maxSum <= 0) return;
      measurements.forEach(({ b, h2, sum }) => {
        if (b && sum < maxSum) {
          b.style.height = (h2 + (maxSum - sum)) + 'px';
        }
      });
    });

    i = j;
  }
}

/* rAF-debounced wrapper so resize/observer/click bursts coalesce */
let _mdEqRaf = null;
function mdScheduleEqualHeights() {
  if (_mdEqRaf) return;
  _mdEqRaf = requestAnimationFrame(() => {
    _mdEqRaf = null;
    mdEqualHeights();
  });
}

/* Initial run — covers the case where window.load already fired */
if (document.readyState === 'complete') {
  mdScheduleEqualHeights();
} else {
  window.addEventListener('load', mdEqualHeights);
}

/* Re-equalize once webfonts swap in (Peachi, DM Sans, etc.) */
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(mdScheduleEqualHeights);
}

window.addEventListener('resize', mdScheduleEqualHeights);

/* Watch every card for any internal content change (lazy images,
   metafield text, badges injected by JS, etc.) and re-equalize. */
if ('ResizeObserver' in window) {
  const _mdRO = new ResizeObserver(mdScheduleEqualHeights);
  document.querySelectorAll('.bf-grid-block').forEach(b => _mdRO.observe(b));
}

jQuery(function ($) {
  if (!document.getElementById('bfcat-terms')) return; /* filter turned off -> show all products */
  const $blocks = $(".bf-grid-block");
  const byHandle = {};
  $blocks.each(function () {
    const h = $(this).data("filter-handle");
    (byHandle[h] = byHandle[h] || []).push(this);
  });

  $("#bfcat-terms").on("click", ".filter-btn", function (e) {
    e.preventDefault();
    const cat = $(this).data("category");
    setActive(this);
    history.pushState(null, "", "#" + cat);
    filterAndOrder(cat);
  });

  /* First run: respect URL hash, else first defined slug */
  const _slugs = Object.keys(_mdCustomSortOrder);
  const start = _mdCustomSortOrder[location.hash.slice(1)]
              ? location.hash.slice(1)
              : (_slugs[0] || "all-products");
  setActive($(`.filter-btn[data-category='${start}']`));
  filterAndOrder(start);

  function filterAndOrder(cat) {
    const list   = _mdCustomSortOrder[cat] || [];
    const max    = 9999;
    let current  = 0;

    $blocks.each(function () { this.style.order = max; });
    list.forEach(h =>
      (byHandle[h] || []).forEach(el => { el.style.order = current++; })
    );
    if (cat === "all") {
      $blocks.filter(function () { return this.style.order == max; })
             .each(function () { this.style.order = current++; });
    }

    $blocks.hide();
    list.forEach(h => (byHandle[h] || []).forEach(el => el.style.display = ""));
    if (cat === "all") $blocks.show();

    $(".cm-header").attr("data-bf-category", cat);
    mdEqualHeights();
  }

  function setActive(btn) {
    $(".filter-btn").removeClass("active");
    $(btn).addClass("active");
  }
});

// ─────────────────────────────────────────────────────────────
//  Super-product-form: variant + buying-option + ATC runtime
// ─────────────────────────────────────────────────────────────
(function (jQuery) {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.super-product-form');
  if (!forms.length) return;

  /* Click delegation for every super-product-form on the page */
  document.body.addEventListener('click', e => {
    const btn = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.super-product-form');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      mdScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('jars-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      mdScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  /* First paint */
  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); f.classList.remove('loading'); });

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const jarButtons = $$$('.jars-option button', form);

    jarButtons.forEach(btn => {
      const txt = isSub ? btn.dataset.displayPerjarSub : btn.dataset.displayPerjarOnetime;
      const priceEl = btn.querySelector('.price-value');
      if (priceEl) priceEl.innerHTML = `${txt} each`;
    });
  }

  function updateBuyingArea(form) {
    const jar = $$('.jars-option .active', form);
    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    const onePrice = parseInt(jar.dataset.priceOnetime || "0");
    const subPrice = parseInt(jar.dataset.priceSubscribe || "0");
    const compareAt = parseInt(jar.dataset.compareAtPrice || "0");

    const displayOne = jar.dataset.displayOnetime;
    const displaySub = jar.dataset.displaySubscribe;
    const displayCompareOne = jar.dataset.displayCompareOnetime;
    const regularPrice = parseInt(jar.dataset.priceRegular || "0");
    const displayRegular = jar.dataset.displayRegular;
    const displayCompareSub = jar.dataset.displayCompareSubscribe;

    if (one) {
      one.innerHTML = (compareAt > onePrice && displayCompareOne)
        ? `<s>${displayCompareOne}</s> ${displayOne}`
        : `${displayOne}`;
    }

    if (sub && subBtn) {
      sub.innerHTML = (compareAt > subPrice && displayCompareSub)
        ? `<s>${displayCompareSub}</s> ${displaySub}`
        : `${displaySub}`;

      /* Fill the dollar savings inside "Subscribe & Save $X.XX" */
      const extraEl = subBtn.querySelector('.extra-savings-value');
      if (extraEl) extraEl.innerHTML = jar.dataset.subscribeSavings || '';
    }

    /* Frequency box visibility (hidden by default; shown when subscribe) */
    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';

    /* Add-to-cart button — pay total + strike the "regular" (same basis as the pill
       and badge: compare-at for bundles, else base×N, floored at price). So the CTA's
       crossed price matches the SAVE X% pill and the pricing table. */
    const atcBtn = $$('.add-to-cart', form);
    if (atcBtn) {
      const totalEl   = atcBtn.querySelector('.atc-total');
      const compareEl = atcBtn.querySelector('.atc-compare');
      let atcTotal, atcCompare;
      if (subMode) {
        atcTotal   = displaySub;
        atcCompare = (regularPrice > subPrice && displayRegular) ? displayRegular : '';
      } else {
        atcTotal   = displayOne;
        atcCompare = (regularPrice > onePrice && displayRegular) ? displayRegular : '';
      }
      if (totalEl)   totalEl.textContent   = atcTotal || '';
      if (compareEl) compareEl.textContent = atcCompare || '';
    }

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }

    /* Auto-select delivery option based on jar count */
    if (subMode && subBox) {
      const activeJar = $$('.jars-option .active', form);
      const jarCount = parseInt(activeJar.dataset.jars || "1");
      const freqButtons = $$$('.frequency-option button', form);

      freqButtons.forEach(btn => btn.classList.remove('active'));
      const index = Math.min(jarCount === 1 ? 0 : jarCount === 2 ? 1 : 2, freqButtons.length - 1);
      freqButtons[index].classList.add('active');
      updateVariantLabelsWithFrequency(form);
    }

    /* Klarna/Shop Pay installment value */
    const shippingInstallment = $$('.su-installment', form);
    const installmentValue = $$('.installment-value', form);
    const rawOnetimeHTML = jar?.dataset.displayOnetime;

    if (shippingInstallment && installmentValue) {
      if (subMode) {
        shippingInstallment.style.display = 'none';
      } else {
        shippingInstallment.style.display = 'block';
        if (rawOnetimeHTML) updateInstallmentDisplay(rawOnetimeHTML, installmentValue);
      }
    }
  }

  function addToCart(form) {
    const variantId   = $$('.jars-option .active', form).dataset.variantId;
    const subMode     = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const planBtn     = $$('.frequency-option .active', form);
    const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
    const quantity    = 1;

    const btn = $$('.add-to-cart', form);
    btn.disabled = true;
    const btnLabel = btn.querySelector('.atc-text');
    if (btnLabel) { btnLabel.textContent = 'Adding…'; } else { btn.textContent = 'Adding…'; }

    const formData = new URLSearchParams({ id: variantId, quantity: quantity });
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          console.error(data.message);
          return;
        }

        /* Notify the Horizon cart drawer (matches pp-superform-horizon.js) */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: variantId.toString(),
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: data.product_id,
              variantId: variantId
            }
          }
        }));

        /* Open the cart drawer after a short delay so it can re-render */
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 300);
      })
      .catch(error => {
        console.error("There was an error adding the product to the cart:", error);
      })
      .finally(() => {
        btn.disabled = false;
        const t = btn.querySelector('.atc-text');
        if (t) { t.textContent = 'Add to Cart'; updateBuyingArea(form); }
        else { btn.textContent = 'Add to Cart'; }
      });
  }

  function updateVariantLabelsWithFrequency(form) {
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const freqButtons = $$$('.frequency-option button', form);
    const jarButtons = $$$('.jars-option button', form);

    if (!subMode || !freqButtons.length || !jarButtons.length) return;

    jarButtons.forEach((btn) => {
      const jars = parseInt(btn.dataset.jars || "1");
      const freqIndex = Math.min(jars === 1 ? 0 : jars === 2 ? 1 : 2, freqButtons.length - 1);
      const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();
      if (!freqTextRaw) return;

      const labelText = `Delivered Every ${freqTextRaw}`;
      const existingSpan = btn.querySelector('.frequency-label');
      if (existingSpan) existingSpan.remove();

      const titleEl = btn.querySelector('.price-title');
      if (titleEl && titleEl.parentNode) {
        const span = document.createElement('span');
        span.className = 'frequency-label';
        span.style.fontSize = '12px';
        span.style.color = '#666';
        span.style.display = 'block';
        span.textContent = labelText;
        titleEl.parentNode.insertBefore(span, titleEl.nextSibling);
      }
    });
  }

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function extractAmountAndCurrency(htmlString) {
    const decoded = decodeHTML(htmlString);
    const match = decoded.match(/([€£$])?\s*([\d.,]+)\s*(\w+)?/i);
    if (!match) return { amount: 0, symbol: "", currency: "" };

    let symbol = match[1] || "";
    let rawAmount = match[2];
    let currency = (match[3] || "").trim();

    /* Normalize EU number formatting */
    if (rawAmount.includes(',') && rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(/\./g, '').replace(',', '.');
    } else if (rawAmount.includes(',') && !rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(',', '.');
    }

    return { symbol: symbol.trim(), amount: parseFloat(rawAmount), currency };
  }

  function updateInstallmentDisplay(displayAttr, valueEl) {
    const { symbol, amount, currency } = extractAmountAndCurrency(displayAttr);
    if (!amount || !valueEl) return;

    const quarter = amount / 4;
    const formatted = quarter.toFixed(2).replace('.', ',');
    valueEl.innerHTML = `${symbol}${formatted} ${currency}`.trim();
  }

  /* Tiny debug helper */
  window.debugTile = sel => updateBuyingArea($$(sel));
})(window.GemQuery || jQuery);

// ─────────────────────────────────────────────────────────────
//  Pro / Basic bullets toggle (special-cased products only)
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const configs = [
    { handle: 'sale-the-ultimate-weight-loss-protocol-3-0', variantId: '45882472661163' },
    { handle: 'new-improved-protocol',                     variantId: '44667017658539' }
  ];

  configs.forEach(({ handle, variantId }) => {
    const gridBlock = document.querySelector(`.bf-grid-block[data-filter-handle="${handle}"]`);
    if (!gridBlock) return;

    const proButton = gridBlock.querySelector(`button[data-variant-id="${variantId}"]`);
    const bullets   = gridBlock.querySelector('.wlp-bullets');
    if (!proButton || !bullets) return;

    const updateBulletsVisibility = () => {
      bullets.style.display = proButton.classList.contains('active') ? 'block' : 'none';
    };

    updateBulletsVisibility();

    const buttons = gridBlock.querySelectorAll('.jars-option button');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateBulletsVisibility();
      });
    });
  });
});

// ─────────────────────────────────────────────────────────────
//  "xxx Products Left" fake-scarcity counter
//  Per-product deterministic start (hashed handle), persisted
//  in localStorage, decays over time (1–2/tick), capped at 50
//  drops/visit, paused when the tab is hidden.
// ─────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const scriptVersion = "v7";

  const today = new Date();
  const inventoryByDate = {
    "2025-11-24": { upper: 1700, lower: 1200 },
    "2025-11-25": { upper: 1700, lower: 1200 },
    "2025-11-26": { upper: 1200, lower: 900 },
    "2025-11-27": { upper: 1200, lower: 900 },
    "2025-11-28": { upper: 900,  lower: 700 },
    "2025-11-29": { upper: 900,  lower: 700 },
    "2025-11-30": { upper: 700,  lower: 400 },
    "2025-12-01": { upper: 700,  lower: 400 },
    "2025-12-02": { upper: 400,  lower: 250 },
    "2025-12-03": { upper: 400,  lower: 250 },
    "2025-12-04": { upper: 250,  lower: 150 },
    "2025-12-05": { upper: 250,  lower: 150 },
    "2025-12-06": { upper: 150,  lower: 80  },
    "2025-12-07": { upper: 150,  lower: 50  }
  };

  const todayKey = today.toISOString().split("T")[0];
  const range = inventoryByDate[todayKey] || { upper: 1700, lower: 1200 };

  const productBlocks = document.querySelectorAll(".bf-grid-block");

  productBlocks.forEach((block) => {
    const handle = block.getAttribute("data-filter-handle");
    const counterEl = block.querySelector(".randomnumber span");
    if (!handle || !counterEl) return;

    const baseKey = btoa(handle).slice(0, 8);
    const countKey = `invdata-${baseKey}`;
    const timeKey = `invts-${baseKey}`;
    const now = Date.now();

    let saved = JSON.parse(localStorage.getItem(countKey));
    let visitStart = parseInt(localStorage.getItem(timeKey)) || now;

    /* Reset if version changed or not found */
    if (!saved || saved.version !== scriptVersion) {
      const spread = Math.abs(hashCode(handle)) % 120;
      const variation = getRandom(-spread / 2, spread / 2);
      const startNum = Math.max(range.lower, Math.min(range.upper, Math.floor(range.upper - 10 - variation)));

      saved = {
        current: startNum,
        lower: range.lower,
        initial: startNum,
        version: scriptVersion
      };
      localStorage.setItem(countKey, JSON.stringify(saved));
      localStorage.setItem(timeKey, now);
    }

    counterEl.textContent = saved.current;

    let visibilityPaused = false;

    function updateCounter() {
      if (document.hidden) {
        visibilityPaused = true;
        return;
      }

      let data = JSON.parse(localStorage.getItem(countKey));
      let timeSpent = (Date.now() - visitStart) / 1000;
      let dropRate;

      if (timeSpent < 300) dropRate = getRandom(1, 2);
      else if (timeSpent < 900) dropRate = getRandom(1, 2);
      else if (timeSpent < 1800) dropRate = 1;
      else dropRate = Math.random() < 0.4 ? 1 : 0;

      const maxDrop = 50;
      const droppedSoFar = saved.initial - data.current;
      if (droppedSoFar >= maxDrop) return;

      if (data.current > data.lower) {
        data.current = Math.max(data.lower, data.current - dropRate);
        counterEl.textContent = data.current;
        localStorage.setItem(countKey, JSON.stringify(data));
      }

      setTimeout(updateCounter, getRandom(10000, 20000));
    }

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && visibilityPaused) {
        visibilityPaused = false;
        updateCounter();
      }
    });

    setTimeout(updateCounter, getRandom(3000, 6000));
  });

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["last-chance-campaign"] && !Shopify.designMode) return;
  try {
    
// ─────────────────────────────────────────────────────────────
//  Sticky buttons: back-to-top + cart fab
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector('.lc-campaign');
  if (!root) return;

  /* Back-to-top: fade in past 40% scroll, smooth scroll on click */
  const btt = root.querySelector('.lc-back-to-top');
  if (btt) {
    window.addEventListener('scroll', function () {
      const pageH = document.documentElement.scrollHeight - window.innerHeight;
      const pct = pageH > 0 ? (window.scrollY / pageH) * 100 : 0;
      btt.classList.toggle('visible', pct > 40);
    }, { passive: true });

    btt.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Cart fab: opens the Horizon cart drawer; hidden when cart is empty */
  const fab = root.querySelector('.lc-cart-fab');
  if (fab) {
    fab.addEventListener('click', function (e) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open();
      }
      // else: fall through to href="/cart" navigation
    });

    const refreshFab = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(c => fab.classList.toggle('is-empty', !c || !c.item_count))
        .catch(() => {});
    };

    document.addEventListener('cart:update', refreshFab);
    refreshFab();
  }
})();

// ─────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────
//  Row alignment: keep cards lined up across each row so swatch
//  tops AND Add-to-Cart buttons share the same Y coordinate.
//
//  Two equalization passes:
//    • SINGLE: each selector equalized independently.
//      Used for sections that have similar content per card and
//      whose own height directly matters (.bf-grid-top settles
//      everything below; .buying-option settles where .jars-option
//      starts).
//    • PAIR : two selectors equalized as a summed total.
//      Used when the two sections trade height (subscribe mode adds
//      to .jars-option but removes installments from
//      .su-shipping-install — net height per card differs even
//      though sum stays similar). Padding is added to the second
//      selector to bring the sum up to the row's max.
//
//  Robust against:
//    • Late {% javascript %} loading (handles `load` already-fired)
//    • Web-font swap reflow (document.fonts.ready)
//    • Image load reflow (window.load)
//    • Filter-applied CSS `order` reordering visual position
//    • Subpixel rounding (3px row tolerance)
//    • Any async content shift in a card (ResizeObserver)
//    • Form state changes — buying-option / jars-option clicks
// ─────────────────────────────────────────────────────────────
const LC_EQ_SELECTORS = ['.bf-grid-top', '.buying-option'];
const LC_EQ_PAIRS     = [['.jars-option', '.su-shipping-install']];
const LC_ROW_TOLERANCE_PX = 3;

function lcEqualHeights() {
  const items = Array.from(document.querySelectorAll('.bf-grid-block'))
    .filter(el => el.offsetParent !== null); /* skip filtered-out cards */
  if (!items.length) return;

  /* Reset everything to natural height so we measure real content. */
  const allSels = LC_EQ_SELECTORS.concat(LC_EQ_PAIRS.flat());
  allSels.forEach(sel => {
    items.forEach(item => {
      const el = item.querySelector(sel);
      if (el) el.style.height = 'auto';
    });
  });

  /* Sort by visual position (top, then left) so DOM order doesn't
     matter — important after the filter sets CSS `order` values. */
  const sorted = items
    .map(el => {
      const r = el.getBoundingClientRect();
      return { el, top: r.top, left: r.left };
    })
    .sort((a, b) => (a.top - b.top) || (a.left - b.left));

  /* Group consecutive items into rows (matching y within tolerance). */
  let i = 0;
  while (i < sorted.length) {
    const rowY = sorted[i].top;
    let j = i;
    while (j < sorted.length && Math.abs(sorted[j].top - rowY) <= LC_ROW_TOLERANCE_PX) j++;
    const rowItems = sorted.slice(i, j).map(o => o.el);

    /* SINGLE pass: independent per-selector equalization */
    LC_EQ_SELECTORS.forEach(sel => {
      let maxH = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(sel);
        if (el) maxH = Math.max(maxH, el.getBoundingClientRect().height);
      });
      if (maxH > 0) {
        rowItems.forEach(item => {
          const el = item.querySelector(sel);
          if (el) el.style.height = maxH + 'px';
        });
      }
    });

    /* PAIR pass: equalize sum(sel1, sel2). Pads the SECOND selector
       up to (rowMaxSum − thisCardSum) so total height matches and
       Add-to-Cart lands on the same Y across the row. */
    LC_EQ_PAIRS.forEach(([sel1, sel2]) => {
      const measurements = rowItems.map(item => {
        const a = item.querySelector(sel1);
        const b = item.querySelector(sel2);
        const h1 = a ? a.getBoundingClientRect().height : 0;
        const h2 = b ? b.getBoundingClientRect().height : 0;
        return { a, b, h1, h2, sum: h1 + h2 };
      });
      const maxSum = measurements.reduce((m, r) => Math.max(m, r.sum), 0);
      if (maxSum <= 0) return;
      measurements.forEach(({ b, h2, sum }) => {
        if (b && sum < maxSum) {
          b.style.height = (h2 + (maxSum - sum)) + 'px';
        }
      });
    });

    i = j;
  }
}

/* rAF-debounced wrapper so resize/observer/click bursts coalesce */
let _lcEqRaf = null;
function lcScheduleEqualHeights() {
  if (_lcEqRaf) return;
  _lcEqRaf = requestAnimationFrame(() => {
    _lcEqRaf = null;
    lcEqualHeights();
  });
}

/* Initial run — covers the case where window.load already fired */
if (document.readyState === 'complete') {
  lcScheduleEqualHeights();
} else {
  window.addEventListener('load', lcEqualHeights);
}

/* Re-equalize once webfonts swap in (Peachi, DM Sans, etc.) */
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(lcScheduleEqualHeights);
}

window.addEventListener('resize', lcScheduleEqualHeights);

/* Watch every card for any internal content change (lazy images,
   metafield text, badges injected by JS, etc.) and re-equalize. */
if ('ResizeObserver' in window) {
  const _lcRO = new ResizeObserver(lcScheduleEqualHeights);
  document.querySelectorAll('.bf-grid-block').forEach(b => _lcRO.observe(b));
}

// Show all products on initial load
document.addEventListener('DOMContentLoaded', () => lcEqualHeights());
window.addEventListener('load', () => lcEqualHeights());

// ─────────────────────────────────────────────────────────────
//  Super-product-form: variant + buying-option + ATC runtime
// ─────────────────────────────────────────────────────────────
(function () {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.super-product-form');
  if (!forms.length) return;

  /* Click delegation for every super-product-form on the page */
  document.body.addEventListener('click', e => {
    const btn = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.super-product-form');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      updateATCPrice(form);
      lcScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('jars-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      updateATCPrice(form);
      lcScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  /* First paint */
  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); updateATCPrice(f); f.classList.remove('loading'); });

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const jarButtons = $$$('.jars-option button', form);

    jarButtons.forEach(btn => {
      const txt = isSub ? btn.dataset.displayPerjarSub : btn.dataset.displayPerjarOnetime;
      const priceEl = btn.querySelector('.price-value');
      if (priceEl) priceEl.innerHTML = `${txt} each`;
    });
  }

  function updateATCPrice(form) {
    const jar = $$('.jars-option .active', form);
    if (!jar) return;

    const isSub = $$('.buying-option .active', form)?.dataset.option === 'subscribe';
    const atcPriceEl = form.querySelector('.add-to-cart .atc-price');
    const atcCompareEl = form.querySelector('.add-to-cart .atc-compare');

    if (atcPriceEl && atcCompareEl) {
      const displayPrice = isSub ? jar.dataset.displaySubscribe : jar.dataset.displayOnetime;
      const displayCompare = isSub ? jar.dataset.displayCompareSubscribe : jar.dataset.displayCompareOnetime;

      atcPriceEl.innerHTML = displayPrice || '';
      atcCompareEl.innerHTML = displayCompare ? displayCompare : '';
    }
  }

  function updateBuyingArea(form) {
    const jar = $$('.jars-option .active', form);
    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    const onePrice = parseInt(jar.dataset.priceOnetime || "0");
    const subPrice = parseInt(jar.dataset.priceSubscribe || "0");
    const compareAt = parseInt(jar.dataset.compareAtPrice || "0");

    const displayOne = jar.dataset.displayOnetime;
    const displaySub = jar.dataset.displaySubscribe;
    const displayCompareOne = jar.dataset.displayCompareOnetime;
    const displayCompareSub = jar.dataset.displayCompareSubscribe;

    if (one) {
      one.innerHTML = (compareAt > onePrice && displayCompareOne)
        ? `<s>${displayCompareOne}</s> ${displayOne}`
        : `${displayOne}`;
    }

    if (sub && subBtn) {
      sub.innerHTML = (compareAt > subPrice && displayCompareSub)
        ? `<s>${displayCompareSub}</s> ${displaySub}`
        : `${displaySub}`;

      /* Fill the dollar savings inside "Subscribe & Save $X.XX" */
      const extraEl = subBtn.querySelector('.extra-savings-value');
      if (extraEl) extraEl.innerHTML = jar.dataset.subscribeSavings || '';
    }

    /* Frequency box visibility (hidden by default; shown when subscribe) */
    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }

    /* Auto-select delivery option based on jar count */
    if (subMode && subBox) {
      const activeJar = $$('.jars-option .active', form);
      const jarCount = parseInt(activeJar.dataset.jars || "1");
      const freqButtons = $$$('.frequency-option button', form);

      freqButtons.forEach(btn => btn.classList.remove('active'));
      const index = Math.min(jarCount === 1 ? 0 : jarCount === 2 ? 1 : 2, freqButtons.length - 1);
      freqButtons[index].classList.add('active');
      updateVariantLabelsWithFrequency(form);
    }

    /* Klarna/Shop Pay installment value */
    const shippingInstallment = $$('.su-installment', form);
    const installmentValue = $$('.installment-value', form);
    const rawOnetimeHTML = jar?.dataset.displayOnetime;

    if (shippingInstallment && installmentValue) {
      if (subMode) {
        shippingInstallment.style.display = 'none';
      } else {
        shippingInstallment.style.display = 'block';
        if (rawOnetimeHTML) updateInstallmentDisplay(rawOnetimeHTML, installmentValue);
      }
    }
  }

  function addToCart(form) {
    const variantId   = $$('.jars-option .active', form).dataset.variantId;
    const subMode     = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const planBtn     = $$('.frequency-option .active', form);
    const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
    const quantity    = 1;

    const btn = $$('.add-to-cart', form);
    /* Update only the label span — the button also holds .atc-price/.atc-compare,
       which setting textContent/innerHTML on the button itself would wipe out. */
    const label = btn.querySelector('.atc-label') || btn;
    const originalLabel = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';

    const formData = new URLSearchParams({ id: variantId, quantity: quantity });
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          console.error(data.message);
          return;
        }

        /* Notify the Horizon cart drawer (matches pp-superform-horizon.js) */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: variantId.toString(),
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: data.product_id,
              variantId: variantId
            }
          }
        }));

        /* Open the cart drawer after a short delay so it can re-render */
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 300);
      })
      .catch(error => {
        console.error("There was an error adding the product to the cart:", error);
      })
      .finally(() => {
        btn.disabled = false;
        label.textContent = originalLabel;
      });
  }

  function updateVariantLabelsWithFrequency(form) {
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const freqButtons = $$$('.frequency-option button', form);
    const jarButtons = $$$('.jars-option button', form);

    if (!subMode || !freqButtons.length || !jarButtons.length) return;

    jarButtons.forEach((btn) => {
      const jars = parseInt(btn.dataset.jars || "1");
      const freqIndex = Math.min(jars === 1 ? 0 : jars === 2 ? 1 : 2, freqButtons.length - 1);
      const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();
      if (!freqTextRaw) return;

      const labelText = `Delivered Every ${freqTextRaw}`;
      const existingSpan = btn.querySelector('.frequency-label');
      if (existingSpan) existingSpan.remove();

      const titleEl = btn.querySelector('.price-title');
      if (titleEl && titleEl.parentNode) {
        const span = document.createElement('span');
        span.className = 'frequency-label';
        span.style.fontSize = '12px';
        span.style.color = '#666';
        span.style.display = 'block';
        span.textContent = labelText;
        titleEl.parentNode.insertBefore(span, titleEl.nextSibling);
      }
    });
  }

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function extractAmountAndCurrency(htmlString) {
    const decoded = decodeHTML(htmlString);
    const match = decoded.match(/([€£$])?\s*([\d.,]+)\s*(\w+)?/i);
    if (!match) return { amount: 0, symbol: "", currency: "" };

    let symbol = match[1] || "";
    let rawAmount = match[2];
    let currency = (match[3] || "").trim();

    /* Normalize EU number formatting */
    if (rawAmount.includes(',') && rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(/\./g, '').replace(',', '.');
    } else if (rawAmount.includes(',') && !rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(',', '.');
    }

    return { symbol: symbol.trim(), amount: parseFloat(rawAmount), currency };
  }

  function updateInstallmentDisplay(displayAttr, valueEl) {
    const { symbol, amount, currency } = extractAmountAndCurrency(displayAttr);
    if (!amount || !valueEl) return;

    const quarter = amount / 4;
    const formatted = quarter.toFixed(2).replace('.', ',');
    valueEl.innerHTML = `${symbol}${formatted} ${currency}`.trim();
  }

  /* Tiny debug helper */
  window.debugTile = sel => updateBuyingArea($$(sel));
})();

// ─────────────────────────────────────────────────────────────
//  Pro / Basic bullets toggle (special-cased products only)
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const configs = [
    { handle: 'sale-the-ultimate-weight-loss-protocol-3-0', variantId: '45882472661163' },
    { handle: 'new-improved-protocol',                     variantId: '44667017658539' }
  ];

  configs.forEach(({ handle, variantId }) => {
    const gridBlock = document.querySelector(`.bf-grid-block[data-filter-handle="${handle}"]`);
    if (!gridBlock) return;

    const proButton = gridBlock.querySelector(`button[data-variant-id="${variantId}"]`);
    const bullets   = gridBlock.querySelector('.wlp-bullets');
    if (!proButton || !bullets) return;

    const updateBulletsVisibility = () => {
      bullets.style.display = proButton.classList.contains('active') ? 'block' : 'none';
    };

    updateBulletsVisibility();

    const buttons = gridBlock.querySelectorAll('.jars-option button');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateBulletsVisibility();
      });
    });
  });
});

// ─────────────────────────────────────────────────────────────
//  "xxx Products Left" fake-scarcity counter
//  Per-product deterministic start (hashed handle), persisted
//  in localStorage, decays over time (1–2/tick), capped at 50
//  drops/visit, paused when the tab is hidden.
// ─────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const scriptVersion = "v7";

  const today = new Date();
  const inventoryByDate = {
    "2025-11-24": { upper: 1700, lower: 1200 },
    "2025-11-25": { upper: 1700, lower: 1200 },
    "2025-11-26": { upper: 1200, lower: 900 },
    "2025-11-27": { upper: 1200, lower: 900 },
    "2025-11-28": { upper: 900,  lower: 700 },
    "2025-11-29": { upper: 900,  lower: 700 },
    "2025-11-30": { upper: 700,  lower: 400 },
    "2025-12-01": { upper: 700,  lower: 400 },
    "2025-12-02": { upper: 400,  lower: 250 },
    "2025-12-03": { upper: 400,  lower: 250 },
    "2025-12-04": { upper: 250,  lower: 150 },
    "2025-12-05": { upper: 250,  lower: 150 },
    "2025-12-06": { upper: 150,  lower: 80  },
    "2025-12-07": { upper: 150,  lower: 50  }
  };

  const todayKey = today.toISOString().split("T")[0];
  const range = inventoryByDate[todayKey] || { upper: 1700, lower: 1200 };

  const productBlocks = document.querySelectorAll(".bf-grid-block");

  productBlocks.forEach((block) => {
    const handle = block.getAttribute("data-filter-handle");
    const counterEl = block.querySelector(".randomnumber span");
    if (!handle || !counterEl) return;

    const baseKey = btoa(handle).slice(0, 8);
    const countKey = `invdata-${baseKey}`;
    const timeKey = `invts-${baseKey}`;
    const now = Date.now();

    let saved = JSON.parse(localStorage.getItem(countKey));
    let visitStart = parseInt(localStorage.getItem(timeKey)) || now;

    /* Reset if version changed or not found */
    if (!saved || saved.version !== scriptVersion) {
      const spread = Math.abs(hashCode(handle)) % 120;
      const variation = getRandom(-spread / 2, spread / 2);
      const startNum = Math.max(range.lower, Math.min(range.upper, Math.floor(range.upper - 10 - variation)));

      saved = {
        current: startNum,
        lower: range.lower,
        initial: startNum,
        version: scriptVersion
      };
      localStorage.setItem(countKey, JSON.stringify(saved));
      localStorage.setItem(timeKey, now);
    }

    counterEl.textContent = saved.current;

    let visibilityPaused = false;

    function updateCounter() {
      if (document.hidden) {
        visibilityPaused = true;
        return;
      }

      let data = JSON.parse(localStorage.getItem(countKey));
      let timeSpent = (Date.now() - visitStart) / 1000;
      let dropRate;

      if (timeSpent < 300) dropRate = getRandom(1, 2);
      else if (timeSpent < 900) dropRate = getRandom(1, 2);
      else if (timeSpent < 1800) dropRate = 1;
      else dropRate = Math.random() < 0.4 ? 1 : 0;

      const maxDrop = 50;
      const droppedSoFar = saved.initial - data.current;
      if (droppedSoFar >= maxDrop) return;

      if (data.current > data.lower) {
        data.current = Math.max(data.lower, data.current - dropRate);
        counterEl.textContent = data.current;
        localStorage.setItem(countKey, JSON.stringify(data));
      }

      setTimeout(updateCounter, getRandom(10000, 20000));
    }

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && visibilityPaused) {
        visibilityPaused = false;
        updateCounter();
      }
    });

    setTimeout(updateCounter, getRandom(3000, 6000));
  });

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-new"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Product card dots sit inside the card link; stop them from navigating to the product
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.card-gallery__dots')) {
      event.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mothers-day-campaign"] && !Shopify.designMode) return;
  try {
    
// ─────────────────────────────────────────────────────────────
//  Sticky buttons: back-to-top + cart fab
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector('.md-campaign');
  if (!root) return;

  /* Back-to-top: fade in past 40% scroll, smooth scroll on click */
  const btt = root.querySelector('.md-back-to-top');
  if (btt) {
    window.addEventListener('scroll', function () {
      const pageH = document.documentElement.scrollHeight - window.innerHeight;
      const pct = pageH > 0 ? (window.scrollY / pageH) * 100 : 0;
      btt.classList.toggle('visible', pct > 40);
    }, { passive: true });

    btt.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Cart fab: opens the Horizon cart drawer; hidden when cart is empty */
  const fab = root.querySelector('.md-cart-fab');
  if (fab) {
    fab.addEventListener('click', function (e) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open();
      }
      // else: fall through to href="/cart" navigation
    });

    const refreshFab = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(c => fab.classList.toggle('is-empty', !c || !c.item_count))
        .catch(() => {});
    };

    document.addEventListener('cart:update', refreshFab);
    refreshFab();
  }
})();

// ─────────────────────────────────────────────────────────────
//  Category filter / grid sort order
//  Reads sort lists from the #md-filter-config JSON tag emitted
//  above (one entry per filter_category block).
// ─────────────────────────────────────────────────────────────
let _mdCustomSortOrder = {};
const _mdConfigEl = document.getElementById('md-filter-config');
if (_mdConfigEl) {
  try { _mdCustomSortOrder = JSON.parse(_mdConfigEl.textContent); }
  catch (e) { console.error('md-filter-config parse error', e); }
}

// ─────────────────────────────────────────────────────────────
//  Row alignment: keep cards lined up across each row so swatch
//  tops AND Add-to-Cart buttons share the same Y coordinate.
//
//  Two equalization passes:
//    • SINGLE: each selector equalized independently.
//      Used for sections that have similar content per card and
//      whose own height directly matters (.bf-grid-top settles
//      everything below; .buying-option settles where .jars-option
//      starts).
//    • PAIR : two selectors equalized as a summed total.
//      Used when the two sections trade height (subscribe mode adds
//      to .jars-option but removes installments from
//      .su-shipping-install — net height per card differs even
//      though sum stays similar). Padding is added to the second
//      selector to bring the sum up to the row's max.
//
//  Robust against:
//    • Late {% javascript %} loading (handles `load` already-fired)
//    • Web-font swap reflow (document.fonts.ready)
//    • Image load reflow (window.load)
//    • Filter-applied CSS `order` reordering visual position
//    • Subpixel rounding (3px row tolerance)
//    • Any async content shift in a card (ResizeObserver)
//    • Form state changes — buying-option / jars-option clicks
// ─────────────────────────────────────────────────────────────
const MD_EQ_SELECTORS = ['.bf-grid-top', '.buying-option'];
const MD_EQ_PAIRS     = [['.jars-option', '.su-shipping-install']];
const MD_ROW_TOLERANCE_PX = 3;

function mdEqualHeights() {
  const items = Array.from(document.querySelectorAll('.bf-grid-block'))
    .filter(el => el.offsetParent !== null); /* skip filtered-out cards */
  if (!items.length) return;

  /* Reset everything to natural height so we measure real content. */
  const allSels = MD_EQ_SELECTORS.concat(MD_EQ_PAIRS.flat());
  allSels.forEach(sel => {
    items.forEach(item => {
      const el = item.querySelector(sel);
      if (el) el.style.height = 'auto';
    });
  });

  /* Sort by visual position (top, then left) so DOM order doesn't
     matter — important after the filter sets CSS `order` values. */
  const sorted = items
    .map(el => {
      const r = el.getBoundingClientRect();
      return { el, top: r.top, left: r.left };
    })
    .sort((a, b) => (a.top - b.top) || (a.left - b.left));

  /* Group consecutive items into rows (matching y within tolerance). */
  let i = 0;
  while (i < sorted.length) {
    const rowY = sorted[i].top;
    let j = i;
    while (j < sorted.length && Math.abs(sorted[j].top - rowY) <= MD_ROW_TOLERANCE_PX) j++;
    const rowItems = sorted.slice(i, j).map(o => o.el);

    /* SINGLE pass: independent per-selector equalization */
    MD_EQ_SELECTORS.forEach(sel => {
      let maxH = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(sel);
        if (el) maxH = Math.max(maxH, el.getBoundingClientRect().height);
      });
      if (maxH > 0) {
        rowItems.forEach(item => {
          const el = item.querySelector(sel);
          if (el) el.style.height = maxH + 'px';
        });
      }
    });

    /* PAIR pass: equalize sum(sel1, sel2). Pads the SECOND selector
       up to (rowMaxSum − thisCardSum) so total height matches and
       Add-to-Cart lands on the same Y across the row. */
    MD_EQ_PAIRS.forEach(([sel1, sel2]) => {
      const measurements = rowItems.map(item => {
        const a = item.querySelector(sel1);
        const b = item.querySelector(sel2);
        const h1 = a ? a.getBoundingClientRect().height : 0;
        const h2 = b ? b.getBoundingClientRect().height : 0;
        return { a, b, h1, h2, sum: h1 + h2 };
      });
      const maxSum = measurements.reduce((m, r) => Math.max(m, r.sum), 0);
      if (maxSum <= 0) return;
      measurements.forEach(({ b, h2, sum }) => {
        if (b && sum < maxSum) {
          b.style.height = (h2 + (maxSum - sum)) + 'px';
        }
      });
    });

    i = j;
  }
}

/* rAF-debounced wrapper so resize/observer/click bursts coalesce */
let _mdEqRaf = null;
function mdScheduleEqualHeights() {
  if (_mdEqRaf) return;
  _mdEqRaf = requestAnimationFrame(() => {
    _mdEqRaf = null;
    mdEqualHeights();
  });
}

/* Initial run — covers the case where window.load already fired */
if (document.readyState === 'complete') {
  mdScheduleEqualHeights();
} else {
  window.addEventListener('load', mdEqualHeights);
}

/* Re-equalize once webfonts swap in (Peachi, DM Sans, etc.) */
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(mdScheduleEqualHeights);
}

window.addEventListener('resize', mdScheduleEqualHeights);

/* Watch every card for any internal content change (lazy images,
   metafield text, badges injected by JS, etc.) and re-equalize. */
if ('ResizeObserver' in window) {
  const _mdRO = new ResizeObserver(mdScheduleEqualHeights);
  document.querySelectorAll('.bf-grid-block').forEach(b => _mdRO.observe(b));
}

jQuery(function ($) {
  const $blocks = $(".bf-grid-block");
  const byHandle = {};
  $blocks.each(function () {
    const h = $(this).data("filter-handle");
    (byHandle[h] = byHandle[h] || []).push(this);
  });

  $("#bfcat-terms").on("click", ".filter-btn", function (e) {
    e.preventDefault();
    const cat = $(this).data("category");
    setActive(this);
    history.pushState(null, "", "#" + cat);
    filterAndOrder(cat);
  });

  /* First run: respect URL hash, else first defined slug */
  const _slugs = Object.keys(_mdCustomSortOrder);
  const start = _mdCustomSortOrder[location.hash.slice(1)]
              ? location.hash.slice(1)
              : (_slugs[0] || "all-products");
  setActive($(`.filter-btn[data-category='${start}']`));
  filterAndOrder(start);

  function filterAndOrder(cat) {
    const list   = _mdCustomSortOrder[cat] || [];
    const max    = 9999;
    let current  = 0;

    $blocks.each(function () { this.style.order = max; });
    list.forEach(h =>
      (byHandle[h] || []).forEach(el => { el.style.order = current++; })
    );
    if (cat === "all") {
      $blocks.filter(function () { return this.style.order == max; })
             .each(function () { this.style.order = current++; });
    }

    $blocks.hide();
    list.forEach(h => (byHandle[h] || []).forEach(el => el.style.display = ""));
    if (cat === "all") $blocks.show();

    $(".cm-header").attr("data-bf-category", cat);
    mdEqualHeights();
  }

  function setActive(btn) {
    $(".filter-btn").removeClass("active");
    $(btn).addClass("active");
  }
});

// ─────────────────────────────────────────────────────────────
//  Super-product-form: variant + buying-option + ATC runtime
// ─────────────────────────────────────────────────────────────
(function (jQuery) {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.super-product-form');
  if (!forms.length) return;

  /* Click delegation for every super-product-form on the page */
  document.body.addEventListener('click', e => {
    const btn = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.super-product-form');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      mdScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('jars-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      mdScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  /* First paint */
  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); f.classList.remove('loading'); });

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const jarButtons = $$$('.jars-option button', form);

    jarButtons.forEach(btn => {
      const txt = isSub ? btn.dataset.displayPerjarSub : btn.dataset.displayPerjarOnetime;
      const priceEl = btn.querySelector('.price-value');
      if (priceEl) priceEl.innerHTML = `${txt} each`;
    });
  }

  function updateBuyingArea(form) {
    const jar = $$('.jars-option .active', form);
    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    const onePrice = parseInt(jar.dataset.priceOnetime || "0");
    const subPrice = parseInt(jar.dataset.priceSubscribe || "0");
    const compareAt = parseInt(jar.dataset.compareAtPrice || "0");

    const displayOne = jar.dataset.displayOnetime;
    const displaySub = jar.dataset.displaySubscribe;
    const displayCompareOne = jar.dataset.displayCompareOnetime;
    const displayCompareSub = jar.dataset.displayCompareSubscribe;

    if (one) {
      one.innerHTML = (compareAt > onePrice && displayCompareOne)
        ? `<s>${displayCompareOne}</s> ${displayOne}`
        : `${displayOne}`;
    }

    if (sub && subBtn) {
      sub.innerHTML = (compareAt > subPrice && displayCompareSub)
        ? `<s>${displayCompareSub}</s> ${displaySub}`
        : `${displaySub}`;

      /* Fill the dollar savings inside "Subscribe & Save $X.XX" */
      const extraEl = subBtn.querySelector('.extra-savings-value');
      if (extraEl) extraEl.innerHTML = jar.dataset.subscribeSavings || '';
    }

    /* Frequency box visibility (hidden by default; shown when subscribe) */
    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }

    /* Auto-select delivery option based on jar count */
    if (subMode && subBox) {
      const activeJar = $$('.jars-option .active', form);
      const jarCount = parseInt(activeJar.dataset.jars || "1");
      const freqButtons = $$$('.frequency-option button', form);

      freqButtons.forEach(btn => btn.classList.remove('active'));
      const index = Math.min(jarCount === 1 ? 0 : jarCount === 2 ? 1 : 2, freqButtons.length - 1);
      freqButtons[index].classList.add('active');
      updateVariantLabelsWithFrequency(form);
    }

    /* Klarna/Shop Pay installment value */
    const shippingInstallment = $$('.su-installment', form);
    const installmentValue = $$('.installment-value', form);
    const rawOnetimeHTML = jar?.dataset.displayOnetime;

    if (shippingInstallment && installmentValue) {
      if (subMode) {
        shippingInstallment.style.display = 'none';
      } else {
        shippingInstallment.style.display = 'block';
        if (rawOnetimeHTML) updateInstallmentDisplay(rawOnetimeHTML, installmentValue);
      }
    }
  }

  function addToCart(form) {
    const variantId   = $$('.jars-option .active', form).dataset.variantId;
    const subMode     = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const planBtn     = $$('.frequency-option .active', form);
    const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
    const quantity    = 1;

    const btn = $$('.add-to-cart', form);
    btn.disabled = true;
    btn.textContent = 'Adding…';

    const formData = new URLSearchParams({ id: variantId, quantity: quantity });
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          console.error(data.message);
          return;
        }

        /* Notify the Horizon cart drawer (matches pp-superform-horizon.js) */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: variantId.toString(),
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: data.product_id,
              variantId: variantId
            }
          }
        }));

        /* Open the cart drawer after a short delay so it can re-render */
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 300);
      })
      .catch(error => {
        console.error("There was an error adding the product to the cart:", error);
      })
      .finally(() => {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
  }

  function updateVariantLabelsWithFrequency(form) {
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const freqButtons = $$$('.frequency-option button', form);
    const jarButtons = $$$('.jars-option button', form);

    if (!subMode || !freqButtons.length || !jarButtons.length) return;

    jarButtons.forEach((btn) => {
      const jars = parseInt(btn.dataset.jars || "1");
      const freqIndex = Math.min(jars === 1 ? 0 : jars === 2 ? 1 : 2, freqButtons.length - 1);
      const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();
      if (!freqTextRaw) return;

      const labelText = `Delivered Every ${freqTextRaw}`;
      const existingSpan = btn.querySelector('.frequency-label');
      if (existingSpan) existingSpan.remove();

      const titleEl = btn.querySelector('.price-title');
      if (titleEl && titleEl.parentNode) {
        const span = document.createElement('span');
        span.className = 'frequency-label';
        span.style.fontSize = '12px';
        span.style.color = '#666';
        span.style.display = 'block';
        span.textContent = labelText;
        titleEl.parentNode.insertBefore(span, titleEl.nextSibling);
      }
    });
  }

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function extractAmountAndCurrency(htmlString) {
    const decoded = decodeHTML(htmlString);
    const match = decoded.match(/([€£$])?\s*([\d.,]+)\s*(\w+)?/i);
    if (!match) return { amount: 0, symbol: "", currency: "" };

    let symbol = match[1] || "";
    let rawAmount = match[2];
    let currency = (match[3] || "").trim();

    /* Normalize EU number formatting */
    if (rawAmount.includes(',') && rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(/\./g, '').replace(',', '.');
    } else if (rawAmount.includes(',') && !rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(',', '.');
    }

    return { symbol: symbol.trim(), amount: parseFloat(rawAmount), currency };
  }

  function updateInstallmentDisplay(displayAttr, valueEl) {
    const { symbol, amount, currency } = extractAmountAndCurrency(displayAttr);
    if (!amount || !valueEl) return;

    const quarter = amount / 4;
    const formatted = quarter.toFixed(2).replace('.', ',');
    valueEl.innerHTML = `${symbol}${formatted} ${currency}`.trim();
  }

  /* Tiny debug helper */
  window.debugTile = sel => updateBuyingArea($$(sel));
})(window.GemQuery || jQuery);

// ─────────────────────────────────────────────────────────────
//  Pro / Basic bullets toggle (special-cased products only)
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const configs = [
    { handle: 'sale-the-ultimate-weight-loss-protocol-3-0', variantId: '45882472661163' },
    { handle: 'new-improved-protocol',                     variantId: '44667017658539' }
  ];

  configs.forEach(({ handle, variantId }) => {
    const gridBlock = document.querySelector(`.bf-grid-block[data-filter-handle="${handle}"]`);
    if (!gridBlock) return;

    const proButton = gridBlock.querySelector(`button[data-variant-id="${variantId}"]`);
    const bullets   = gridBlock.querySelector('.wlp-bullets');
    if (!proButton || !bullets) return;

    const updateBulletsVisibility = () => {
      bullets.style.display = proButton.classList.contains('active') ? 'block' : 'none';
    };

    updateBulletsVisibility();

    const buttons = gridBlock.querySelectorAll('.jars-option button');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateBulletsVisibility();
      });
    });
  });
});

// ─────────────────────────────────────────────────────────────
//  "xxx Products Left" fake-scarcity counter
//  Per-product deterministic start (hashed handle), persisted
//  in localStorage, decays over time (1–2/tick), capped at 50
//  drops/visit, paused when the tab is hidden.
// ─────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const scriptVersion = "v7";

  const today = new Date();
  const inventoryByDate = {
    "2025-11-24": { upper: 1700, lower: 1200 },
    "2025-11-25": { upper: 1700, lower: 1200 },
    "2025-11-26": { upper: 1200, lower: 900 },
    "2025-11-27": { upper: 1200, lower: 900 },
    "2025-11-28": { upper: 900,  lower: 700 },
    "2025-11-29": { upper: 900,  lower: 700 },
    "2025-11-30": { upper: 700,  lower: 400 },
    "2025-12-01": { upper: 700,  lower: 400 },
    "2025-12-02": { upper: 400,  lower: 250 },
    "2025-12-03": { upper: 400,  lower: 250 },
    "2025-12-04": { upper: 250,  lower: 150 },
    "2025-12-05": { upper: 250,  lower: 150 },
    "2025-12-06": { upper: 150,  lower: 80  },
    "2025-12-07": { upper: 150,  lower: 50  }
  };

  const todayKey = today.toISOString().split("T")[0];
  const range = inventoryByDate[todayKey] || { upper: 1700, lower: 1200 };

  const productBlocks = document.querySelectorAll(".bf-grid-block");

  productBlocks.forEach((block) => {
    const handle = block.getAttribute("data-filter-handle");
    const counterEl = block.querySelector(".randomnumber span");
    if (!handle || !counterEl) return;

    const baseKey = btoa(handle).slice(0, 8);
    const countKey = `invdata-${baseKey}`;
    const timeKey = `invts-${baseKey}`;
    const now = Date.now();

    let saved = JSON.parse(localStorage.getItem(countKey));
    let visitStart = parseInt(localStorage.getItem(timeKey)) || now;

    /* Reset if version changed or not found */
    if (!saved || saved.version !== scriptVersion) {
      const spread = Math.abs(hashCode(handle)) % 120;
      const variation = getRandom(-spread / 2, spread / 2);
      const startNum = Math.max(range.lower, Math.min(range.upper, Math.floor(range.upper - 10 - variation)));

      saved = {
        current: startNum,
        lower: range.lower,
        initial: startNum,
        version: scriptVersion
      };
      localStorage.setItem(countKey, JSON.stringify(saved));
      localStorage.setItem(timeKey, now);
    }

    counterEl.textContent = saved.current;

    let visibilityPaused = false;

    function updateCounter() {
      if (document.hidden) {
        visibilityPaused = true;
        return;
      }

      let data = JSON.parse(localStorage.getItem(countKey));
      let timeSpent = (Date.now() - visitStart) / 1000;
      let dropRate;

      if (timeSpent < 300) dropRate = getRandom(1, 2);
      else if (timeSpent < 900) dropRate = getRandom(1, 2);
      else if (timeSpent < 1800) dropRate = 1;
      else dropRate = Math.random() < 0.4 ? 1 : 0;

      const maxDrop = 50;
      const droppedSoFar = saved.initial - data.current;
      if (droppedSoFar >= maxDrop) return;

      if (data.current > data.lower) {
        data.current = Math.max(data.lower, data.current - dropRate);
        counterEl.textContent = data.current;
        localStorage.setItem(countKey, JSON.stringify(data));
      }

      setTimeout(updateCounter, getRandom(10000, 20000));
    }

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && visibilityPaused) {
        visibilityPaused = false;
        updateCounter();
      }
    });

    setTimeout(updateCounter, getRandom(3000, 6000));
  });

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["season-reset-campaign"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('.sr-campaign');
  if (!root) return;

  const btt = root.querySelector('.sr-back-to-top');
  const fab = root.querySelector('.sr-cart-fab');

  /* Both buttons only appear once the first grid row has fully scrolled past
     (its bottom edge above the viewport) — not a page-scroll percentage, and
     not tied only to cart contents. The cart icon still also requires the
     cart to actually have items; .is-empty (existing CSS: display:none) now
     represents "hidden for either reason", not literally an empty cart. */
  let cartHasItems = false;

  /* Resolved fresh on every check rather than cached once at load: the filter
     buttons reorder cards via CSS `order` (not DOM order) and hide non-matching
     ones with display:none. A single .bf-grid-block grabbed once at init is
     whichever product happens to be first in raw HTML — if that particular one
     is hidden under the active filter, its getBoundingClientRect() comes back
     all-zero, so "bottom < 0" reads as permanently false and the buttons never
     appear on that filter, no matter how far you scroll. Re-resolving by
     visible position (top, then left) instead of DOM order always finds
     whichever card is actually rendered first under the current filter. */
  function getFirstVisibleBlock() {
    const blocks = Array.from(root.querySelectorAll('.bf-grid-block')).filter(el => el.offsetParent !== null);
    if (!blocks.length) return null;
    return blocks
      .map(el => ({ el, rect: el.getBoundingClientRect() }))
      .sort((a, b) => (a.rect.top - b.rect.top) || (a.rect.left - b.rect.left))[0].el;
  }

  function updateStickyButtons() {
    const firstBlock = getFirstVisibleBlock();
    const pastFirstRow = !!firstBlock && firstBlock.getBoundingClientRect().bottom < 0;
    if (btt) btt.classList.toggle('visible', pastFirstRow);
    if (fab) fab.classList.toggle('is-empty', !(cartHasItems && pastFirstRow));
  }

  if (btt || fab) {
    window.addEventListener('scroll', updateStickyButtons, { passive: true });
    updateStickyButtons();
  }

  // Exposed so the filter click handler further down (a separate IIFE) can
  // force an immediate re-check right after switching filters, instead of
  // waiting for the next scroll event to notice the new first-visible-block.
  window.srUpdateStickyButtons = updateStickyButtons;

  if (btt) {
    btt.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (fab) {
    fab.addEventListener('click', function (e) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open();
      }
    });

    const refreshFab = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(c => {
          cartHasItems = !!(c && c.item_count);
          updateStickyButtons();
        })
        .catch(() => {});
    };

    document.addEventListener('cart:update', refreshFab);
    refreshFab();
  }
})();

// ─────────────────────────────────────────────────────────────
//  Row alignment: keep cards lined up across each row.
// ─────────────────────────────────────────────────────────────
const SR_EQ_SELECTORS = ['.bf-grid-top', '.buying-option'];
const SR_EQ_PAIRS     = [['.jars-option', '.su-shipping-install']];
const SR_ROW_TOLERANCE_PX = 3;

function srEqualHeights() {
  const items = Array.from(document.querySelectorAll('.sr-campaign .bf-grid-block'))
    .filter(el => el.offsetParent !== null);
  if (!items.length) return;

  const allSels = SR_EQ_SELECTORS.concat(SR_EQ_PAIRS.flat());
  allSels.forEach(sel => {
    items.forEach(item => {
      const el = item.querySelector(sel);
      if (el) el.style.height = 'auto';
    });
  });

  const sorted = items
    .map(el => {
      const r = el.getBoundingClientRect();
      return { el, top: r.top, left: r.left };
    })
    .sort((a, b) => (a.top - b.top) || (a.left - b.left));

  let i = 0;
  while (i < sorted.length) {
    const rowY = sorted[i].top;
    let j = i;
    while (j < sorted.length && Math.abs(sorted[j].top - rowY) <= SR_ROW_TOLERANCE_PX) j++;
    const rowItems = sorted.slice(i, j).map(o => o.el);

    SR_EQ_SELECTORS.forEach(sel => {
      let maxH = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(sel);
        if (el) maxH = Math.max(maxH, el.getBoundingClientRect().height);
      });
      if (maxH > 0) {
        rowItems.forEach(item => {
          const el = item.querySelector(sel);
          if (el) el.style.height = maxH + 'px';
        });
      }
    });

    SR_EQ_PAIRS.forEach(([sel1, sel2]) => {
      const measurements = rowItems.map(item => {
        const a = item.querySelector(sel1);
        const b = item.querySelector(sel2);
        const h1 = a ? a.getBoundingClientRect().height : 0;
        const h2 = b ? b.getBoundingClientRect().height : 0;
        return { a, b, h1, h2, sum: h1 + h2 };
      });
      const maxSum = measurements.reduce((m, r) => Math.max(m, r.sum), 0);
      if (maxSum <= 0) return;
      measurements.forEach(({ b, h2, sum }) => {
        if (b && sum < maxSum) {
          b.style.height = (h2 + (maxSum - sum)) + 'px';
        }
      });
    });

    i = j;
  }
}

let _srEqRaf = null;
function srScheduleEqualHeights() {
  if (_srEqRaf) return;
  _srEqRaf = requestAnimationFrame(() => {
    _srEqRaf = null;
    srEqualHeights();
  });
}

if (document.readyState === 'complete') {
  srScheduleEqualHeights();
} else {
  window.addEventListener('load', srEqualHeights);
}
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(srScheduleEqualHeights);
}
window.addEventListener('resize', srScheduleEqualHeights);
if ('ResizeObserver' in window) {
  const _srRO = new ResizeObserver(srScheduleEqualHeights);
  document.querySelectorAll('.sr-campaign .bf-grid-block').forEach(b => _srRO.observe(b));
}
document.addEventListener('DOMContentLoaded', () => srEqualHeights());
window.addEventListener('load', () => srEqualHeights());

// ─────────────────────────────────────────────────────────────
//  Category filter / grid sort order.
//  The custom content block (if present) is fixed at flex `order: 2`
//  in CSS — always the 3rd visual slot. The loop below skips that
//  order value when assigning positions to product cards, so a
//  product is never assigned the same order and the two can't collide.
// ─────────────────────────────────────────────────────────────
(function () {
  const hasCustomBlock = !!document.querySelector('.sr-campaign .sr-custom-block');
  const RESERVED_ORDER = 2;

  const $blocks = Array.from(document.querySelectorAll('.sr-campaign .bf-grid-block'));
  if (!$blocks.length) return;

  const byHandle = {};
  $blocks.forEach(el => {
    const h = el.getAttribute('data-filter-handle');
    (byHandle[h] = byHandle[h] || []).push(el);
  });

  function assignOrder(orderedBlocks) {
    let current = 0;
    function nextOrder() {
      if (hasCustomBlock && current === RESERVED_ORDER) current++;
      return current++;
    }
    orderedBlocks.forEach(el => { el.style.order = nextOrder(); });
  }

  const filterRoot = document.getElementById('sr-filter-terms');
  if (!filterRoot) {
    /* No filter tabs configured — still reserve the 3rd slot for the custom
       block (if any); every product stays visible in natural DOM order. */
    assignOrder($blocks);
    return;
  }

  let _srCustomSortOrder = {};
  const _srConfigEl = document.getElementById('sr-filter-config');
  if (_srConfigEl) {
    try { _srCustomSortOrder = JSON.parse(_srConfigEl.textContent); }
    catch (e) { console.error('sr-filter-config parse error', e); }
  }

  filterRoot.addEventListener('click', function (e) {
    const btn = e.target.closest('.sr-filter-btn');
    if (!btn) return;
    e.preventDefault();
    const cat = btn.getAttribute('data-category');
    setActive(btn);
    history.pushState(null, '', '#' + cat);
    filterAndOrder(cat);
  });

  const slugs = Object.keys(_srCustomSortOrder);
  const startHash = location.hash.slice(1);
  const start = _srCustomSortOrder[startHash] ? startHash : (slugs[0] || 'all');
  setActive(filterRoot.querySelector(`.sr-filter-btn[data-category="${start}"]`));
  filterAndOrder(start);

  function filterAndOrder(cat) {
    const list = _srCustomSortOrder[cat] || [];

    const matched = [];
    list.forEach(h => (byHandle[h] || []).forEach(el => matched.push(el)));
    const rest = $blocks.filter(el => !matched.includes(el));
    assignOrder(cat === 'all' ? matched.concat(rest) : matched);

    $blocks.forEach(el => { el.style.display = 'none'; });
    matched.forEach(el => { el.style.display = ''; });
    if (cat === 'all') $blocks.forEach(el => { el.style.display = ''; });

    srEqualHeights();
    if (window.srUpdateStickyButtons) window.srUpdateStickyButtons();
  }

  function setActive(btn) {
    if (!btn) return;
    filterRoot.querySelectorAll('.sr-filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }
})();

// ─────────────────────────────────────────────────────────────
//  Super-product-form: variant + buying-option + ATC runtime
//
//  Quantity (jars-option) and Flavor (flavor-option, if the product has a
//  2nd option) are independent selectors — NOT one button per variant. The
//  matching variant is resolved from the `.sr-variant-matrix` JSON (emitted
//  per card in season-reset-product-card.liquid) keyed "qtyValue||flavorValue",
//  so a 3-flavor x 3-jar product renders 3 + 3 buttons instead of 9.
// ─────────────────────────────────────────────────────────────
(function () {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.sr-campaign .super-product-form');
  if (!forms.length) return;

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.sr-campaign .super-product-form');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      updateATCPrice(form);
      srScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('jars-option') || btn.parentElement.classList.contains('flavor-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form);
      updateATCPrice(form);
      srScheduleEqualHeights();
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); updateATCPrice(f); });

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function getMatrix(form) {
    if (form._srMatrix) return form._srMatrix;
    const script = form.querySelector('.sr-variant-matrix');
    let matrix = {};
    if (script) {
      try { matrix = JSON.parse(script.textContent); }
      catch (e) { console.error('sr-variant-matrix parse error', e); }
    }
    form._srMatrix = matrix;
    return matrix;
  }

  function getSelectedQty(form) {
    return $$('.jars-option .active', form)?.dataset.value || '';
  }

  function getSelectedFlavor(form) {
    return $$('.flavor-option .active', form)?.dataset.value || '';
  }

  /* Resolves the matrix entry for a given qty/flavor pair, defaulting to the
     currently-active buttons. Falls back to the flavor-less key so single-option
     products (no .flavor-option group at all) still resolve correctly. */
  function resolveVariant(form, qtyValue, flavorValue) {
    const matrix = getMatrix(form);
    const q = qtyValue !== undefined ? qtyValue : getSelectedQty(form);
    const f = flavorValue !== undefined ? flavorValue : getSelectedFlavor(form);
    return matrix[q + '||' + f] || matrix[q + '||'] || null;
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form)?.dataset.option === 'subscribe';
    const flavorValue = getSelectedFlavor(form);

    $$$('.jars-option button', form).forEach(btn => {
      const v = resolveVariant(form, btn.dataset.value, flavorValue);
      const priceEl = btn.querySelector('.price-value');
      if (priceEl && v) priceEl.innerHTML = `${isSub ? v.perJarSubscribe : v.perJarOnetime} each`;
    });
  }

  function updateATCPrice(form) {
    const v = resolveVariant(form);
    if (!v) return;

    const isSub = $$('.buying-option .active', form)?.dataset.option === 'subscribe';
    const atcPriceEl = form.querySelector('.add-to-cart .atc-price');
    const atcCompareEl = form.querySelector('.add-to-cart .atc-compare');

    if (atcPriceEl && atcCompareEl) {
      atcPriceEl.innerHTML = isSub ? v.priceSubscribe : v.priceOnetime;
      atcCompareEl.innerHTML = isSub ? (v.compareSubscribe || '') : (v.hasCompareOnetime ? v.compareOnetime : '');
    }
  }

  function updateBuyingArea(form) {
    const v = resolveVariant(form);
    if (!v) return;

    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    if (one) {
      one.innerHTML = v.hasCompareOnetime
        ? `<span class="sr-price-compare">${v.compareOnetime}</span><span class="sr-price-current">${v.priceOnetime}</span>`
        : `<span class="sr-price-current">${v.priceOnetime}</span>`;
    }

    if (sub && subBtn) {
      sub.innerHTML = v.compareSubscribe
        ? `<span class="sr-price-compare">${v.compareSubscribe}</span><span class="sr-price-current">${v.priceSubscribe}</span>`
        : `<span class="sr-price-current">${v.priceSubscribe}</span>`;

      const extraEl = subBtn.querySelector('.extra-savings-value');
      if (extraEl) extraEl.textContent = v.subscribeSavingsPct > 0 ? `${v.subscribeSavingsPct}%` : '';
    }

    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form)?.dataset.option === 'subscribe';

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }

    if (subMode && subBox) {
      // Position-based, not value-based: mapping by literal jar count (1 → idx0,
      // 2 → idx1, else → idx2) only worked by coincidence for 1/2/4-jar products.
      // A 3/6/15-pack product (e.g. organic-bone-broth) has none of its values
      // equal to 1 or 2, so all three quantities fell into "else" and always
      // selected the LAST frequency option — matches the reported bug where every
      // pack size showed the same (highest) delivery frequency. Using the
      // quantity button's own position among its siblings instead works
      // regardless of the actual jar/pack numbers involved, same principle as
      // the position-based Best Seller/Best Value badges above.
      const jarButtonsList = $$$('.jars-option button', form);
      const activeJar = $$('.jars-option .active', form);
      const jarIndex = Array.prototype.indexOf.call(jarButtonsList, activeJar);
      const freqButtons = $$$('.frequency-option button', form);

      freqButtons.forEach(btn => btn.classList.remove('active'));
      const index = Math.min(jarIndex >= 0 ? jarIndex : 0, freqButtons.length - 1);
      if (freqButtons[index]) freqButtons[index].classList.add('active');
    }

    updateVariantLabelsWithFrequency(form);
  }

  /* "Delivered every X" label under each jar button — only while subscribing. Maps
     the quantity button's own position to the frequency-option button at the same
     position (not by matching literal jar/pack counts — see the comment in
     updateBuyingArea() above), so it shows the delivery cadence for THAT quantity
     option, not just whichever one is active. */
  function updateVariantLabelsWithFrequency(form) {
    const subMode = $$('.buying-option .active', form)?.dataset.option === 'subscribe';
    const freqButtons = $$$('.frequency-option button', form);
    const jarButtons = $$$('.jars-option button', form);

    if (!subMode || !freqButtons.length || !jarButtons.length) return;

    jarButtons.forEach((btn, jarIndex) => {
      const freqIndex = Math.min(jarIndex, freqButtons.length - 1);
      const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();
      if (!freqTextRaw) return;

      const labelText = `Delivered every ${freqTextRaw}`;
      const existingSpan = btn.querySelector('.frequency-label');
      if (existingSpan) existingSpan.remove();

      const span = document.createElement('span');
      span.className = 'frequency-label';
      span.textContent = labelText;
      btn.appendChild(span);
    });
  }

  function addToCart(form) {
    const v = resolveVariant(form);
    if (!v) return;

    const variantId   = v.variantId;
    const subMode     = $$('.buying-option .active', form)?.dataset.option === 'subscribe';
    const planBtn     = $$('.frequency-option .active', form);
    const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
    const quantity    = 1;

    const btn = $$('.add-to-cart', form);
    const label = btn.querySelector('.atc-label') || btn;
    const originalLabel = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';

    const formData = new URLSearchParams({ id: variantId, quantity: quantity });
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          console.error(data.message);
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: variantId.toString(),
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: data.product_id,
              variantId: variantId
            }
          }
        }));

        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }, 300);
      })
      .catch(error => {
        console.error("There was an error adding the product to the cart:", error);
      })
      .finally(() => {
        btn.disabled = false;
        label.textContent = originalLabel;
      });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
